(function() {
'use strict';

// ── DO NOT LOAD ON CONSIGNOR SUBMISSION PAGES ─────────────────────────
// Zara is not relevant when a consignor is submitting items.
// Returning here prevents any DOM injection, CSS injection, or event
// binding from happening on these pages at all.
var _bopfPath = window.location.pathname;
if (_bopfPath.indexOf('/pages/submit-items-for-sale') > -1 ||
    _bopfPath.indexOf('/pages/submit-your-items')     > -1) { return; }

// ── DYNAMIC FAVICON INJECTION ─────────────────────────────────────────
// Theme-level favicon went missing (Shopify Theme Settings cleared, or
// the theme.liquid <link rel="icon"> got overwritten in a theme update).
// We inject our own <link> tags into <head> on every page load as a
// belt-and-braces fallback. Permanent fix is to upload favicon-32.png /
// favicon-192.png to Shopify > Online Store > Themes > Customize > Theme
// settings > Favicon. This runtime injection covers the case until that
// happens, and continues to work as a safety net afterward (browsers
// honor the most recently-added <link rel="icon"> when multiple exist).
//
// Two SVG variants are embedded as base64 data URIs:
//   - Detail (sangles + lock + handle): for 32px and up.
//   - Simplified (sangles + lock dropped, heavier strokes): for 16px tabs
//     where the detail strokes blur into mush.
// Browsers pick the closest matching size from the available <link> tags.
//
// IMPORTANT: this runs after DOMContentLoaded (or immediately if the page
// is already loaded). Earlier versions ran inline at script-eval time
// which silently failed in some Shopify environments where document.head
// wasn't ready yet OR the theme's deferred head population overwrote our
// links. Running after DOMContentLoaded matches the pattern used for the
// rest of the widget's renderers and is the consistently-working timing.
//
// Self-healing: this storefront has a theme-level head re-render (likely
// from a sectioned/dynamic rendering app) that strips our links between
// DOMContentLoaded and full window load. We solve that two ways:
//   1. Re-inject on multiple timing signals (DOMContentLoaded, load, then
//      a 1s and 3s delayed retry) so we cover whatever timing the
//      head-rewriter uses.
//   2. A MutationObserver on document.head re-injects within a tick if
//      our links are removed by anything later. The observer is set up
//      once and runs for the page's lifetime.

var DETAIL_DATA_URI  = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTAiIGZpbGw9IiNCODY4NDIiLz4KICA8cGF0aCBkPSJNMTYgMjYgTDE2IDMzIEw0OCAzMyBMNDggMjYgWiIgc3Ryb2tlPSIjRkJGM0VFIiBzdHJva2Utd2lkdGg9IjIuNCIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik0xOSAzMyBMMTMgNTAgTDUxIDUwIEw0NSAzMyBaIiBzdHJva2U9IiNGQkYzRUUiIHN0cm9rZS13aWR0aD0iMi40IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPGxpbmUgeDE9IjI1IiB5MT0iMjYiIHgyPSIyNSIgeTI9IjM4IiBzdHJva2U9IiNGQkYzRUUiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSB4MT0iMzkiIHkxPSIyNiIgeDI9IjM5IiB5Mj0iMzgiIHN0cm9rZT0iI0ZCRjNFRSIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik0yOCAyNiBMMjggMjIgUTI4IDE5LjUgMzAuNSAxOS41IEwzMy41IDE5LjUgUTM2IDE5LjUgMzYgMjIgTDM2IDI2IiBzdHJva2U9IiNGQkYzRUUiIHN0cm9rZS13aWR0aD0iMi4yIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8cmVjdCB4PSIyOCIgeT0iMzYiIHdpZHRoPSI4IiBoZWlnaHQ9IjQiIHN0cm9rZT0iI0ZCRjNFRSIgc3Ryb2tlLXdpZHRoPSIxLjYiIGZpbGw9Im5vbmUiIHJ4PSIwLjUiLz4KPC9zdmc+Cg==';
var SIMPLE_DATA_URI  = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTAiIGZpbGw9IiNCODY4NDIiLz4KICA8cGF0aCBkPSJNMTYgMjYgTDE2IDMzIEw0OCAzMyBMNDggMjYgWiIgc3Ryb2tlPSIjRkJGM0VFIiBzdHJva2Utd2lkdGg9IjMuNSIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik0xOSAzMyBMMTMgNTAgTDUxIDUwIEw0NSAzMyBaIiBzdHJva2U9IiNGQkYzRUUiIHN0cm9rZS13aWR0aD0iMy41IiBmaWxsPSJub25lIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPHBhdGggZD0iTTI4IDI2IEwyOCAyMiBRMjggMTkuNSAzMC41IDE5LjUgTDMzLjUgMTkuNSBRMzYgMTkuNSAzNiAyMiBMMzYgMjYiIHN0cm9rZT0iI0ZCRjNFRSIgc3Ryb2tlLXdpZHRoPSIzIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==';

// The set of links we want present at all times.
var BOPF_FAVICON_LINKS = [
  { rel: 'icon', type: 'image/svg+xml', sizes: '16x16',   href: SIMPLE_DATA_URI },
  { rel: 'icon', type: 'image/svg+xml', sizes: '32x32',   href: DETAIL_DATA_URI },
  { rel: 'icon', type: 'image/svg+xml', sizes: '192x192', href: DETAIL_DATA_URI },
  { rel: 'icon', type: 'image/svg+xml', sizes: '512x512', href: DETAIL_DATA_URI },
  { rel: 'apple-touch-icon', type: null, sizes: '180x180', href: DETAIL_DATA_URI }
];

function injectBOPFFavicon() {
  try {
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return;
    // Idempotent: only add a link if one with the same rel+sizes isn't already
    // present and tagged as ours. Prevents duplicate accumulation if we re-run.
    BOPF_FAVICON_LINKS.forEach(function(spec) {
      var sel = 'link[data-bopf-favicon][rel="' + spec.rel + '"]' + (spec.sizes ? '[sizes="' + spec.sizes + '"]' : '');
      if (head.querySelector(sel)) return;
      var l = document.createElement('link');
      l.setAttribute('rel', spec.rel);
      if (spec.type)  l.setAttribute('type',  spec.type);
      if (spec.sizes) l.setAttribute('sizes', spec.sizes);
      l.setAttribute('href', spec.href);
      l.setAttribute('data-bopf-favicon', '1');
      head.appendChild(l);
    });
  } catch (e) {
    // Surface the error if it ever fails - favicon issues should not break
    // anything else, but we want visibility.
    console.error('[bopf favicon] inject failed:', e && e.message);
  }
}

// Self-healing watch: if our links get removed by a theme head-rewriter,
// re-inject within a tick. Set up once, runs for page lifetime.
function startBOPFFaviconWatcher() {
  try {
    if (window._bopfFaviconWatcherStarted) return;
    window._bopfFaviconWatcherStarted = true;
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head || typeof MutationObserver !== 'function') return;
    var pendingReinject = false;
    var observer = new MutationObserver(function(mutations) {
      // Cheap fast path: only do work if a node we care about was removed.
      var ourNodeRemoved = false;
      for (var i = 0; i < mutations.length; i++) {
        var removed = mutations[i].removedNodes;
        for (var j = 0; j < removed.length; j++) {
          var n = removed[j];
          if (n && n.nodeType === 1 && n.getAttribute && n.getAttribute('data-bopf-favicon')) {
            ourNodeRemoved = true;
            break;
          }
        }
        if (ourNodeRemoved) break;
      }
      if (ourNodeRemoved && !pendingReinject) {
        pendingReinject = true;
        // Defer re-injection by a microtask so we don't fight the same
        // mutation that just removed us in a tight loop.
        Promise.resolve().then(function() {
          pendingReinject = false;
          injectBOPFFavicon();
        });
      }
    });
    observer.observe(head, { childList: true });
  } catch (e) {
    // Watcher failure shouldn't break the page.
  }
}

// Run injection at every reasonable signal so we cover whatever timing
// the theme's head-rewriter uses:
//   - Immediately if DOM is already past loading
//   - On DOMContentLoaded (covers the typical case)
//   - On window load (covers themes that re-render head after parse)
//   - At 1s and 3s post-load (covers async sectioned-rendering apps)
//   - Plus the MutationObserver self-heal for anything else
function scheduleBOPFFaviconInject() {
  injectBOPFFavicon();
  startBOPFFaviconWatcher();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBOPFFavicon);
  }
  window.addEventListener('load', injectBOPFFavicon);
  setTimeout(injectBOPFFavicon, 1000);
  setTimeout(injectBOPFFavicon, 3000);
}
scheduleBOPFFaviconInject();

var _XHR       = (window._bopfXHR && window._bopfXHR.cls)    || window.XMLHttpRequest;
var _xhrOpen   = (window._bopfXHR && window._bopfXHR.open)   || window.XMLHttpRequest.prototype.open;
var _xhrSend   = (window._bopfXHR && window._bopfXHR.send)   || window.XMLHttpRequest.prototype.send;
var _xhrHeader = (window._bopfXHR && window._bopfXHR.header) || window.XMLHttpRequest.prototype.setRequestHeader;

// ── CONFIG ────────────────────────────────────────────────────────────
var TOKEN      = 'cbfa4b94c62b1018c8398d2a3929467a';
var DOMAIN     = 'businessofprelovedfashion.myshopify.com';
var WA         = '971585669311';
var PROXY_URL  = '/apps/bopf/chat';
var LOG_URL    = '/apps/bopf/log';
var LOGO       = 'https://businessofprelovedfashion.com/cdn/shop/files/Black_logo-jpeg-01_54616b3a-277d-49b3-aa69-db986238bf6e_512x.jpg?v=1671987556';

// ── SESSION ID ────────────────────────────────────────────────────────
var SESSION_ID = (function() {
  var stored = sessionStorage.getItem('bopf_session_id');
  if (stored) return stored;
  var d = new Date();
  var ds = '' + d.getFullYear() + ('0'+(d.getMonth()+1)).slice(-2) + ('0'+d.getDate()).slice(-2);
  var id = 'bopf_' + ds + '_' + Math.random().toString(36).slice(2, 8);
  try { sessionStorage.setItem('bopf_session_id', id); } catch(e) {}
  return id;
})();

// ── ANALYTICS STATE ───────────────────────────────────────────────────
var messageCount = 0;
var cartValueAtStart = 0;
var archetypeContextSent = false;

// ── OMNISEND CAMPAIGN FRESHNESS FLAG ──────────────────────────────────
// Gates the "What's new this week" suggestion chip. Set by a single
// non-blocking fetch on widget load. If the request is slow or fails,
// the chip simply doesn't appear, graceful degradation. No retry logic
// because a single missed signal per page-load is harmless.
var omnisendFresh = false;
(function fetchOmnisendFreshness() {
  try {
    fetch('/apps/bopf/health', { method: 'GET', cache: 'no-store' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        // Server filters to within-21-days already. We just read the flag.
        if (d && d.omnisendFresh === true) {
          omnisendFresh = true;
        }
      })
      .catch(function(){ /* silent - chip just won't show */ });
  } catch(e) { /* older browsers without fetch - same graceful fallback */ }
})();

// ── UTM HELPER ────────────────────────────────────────────────────────
function appendUTM(url) {
  if (!url) return url;
  var sep = url.indexOf('?') > -1 ? '&' : '?';
  return url + sep
    + 'utm_source=bopf_widget'
    + '&utm_medium=chat'
    + '&utm_campaign=ai_concierge'
    + '&utm_content=' + SESSION_ID;
}

// ── EVENT LOGGER ──────────────────────────────────────────────────────
function logEvent(eventType, eventDetail) {
  try {
    var xhr = new _XHR();
    _xhrOpen.call(xhr, 'POST', LOG_URL, true);
    _xhrHeader.call(xhr, 'Content-Type', 'application/json');
    xhr.timeout = 5000;
    _xhrSend.call(xhr, JSON.stringify({
      sessionId:     SESSION_ID,
      pageUrl:       window.location.href,
      visitorRegion: isUAEVisitor() ? 'UAE' : 'International',
      messageNumber: messageCount,
      cartValue:     cartValueAtStart,
      eventType:     eventType,
      eventDetail:   eventDetail
    }));
  } catch(e) {}
}

// ── QUIZ ARCHETYPE HELPERS ────────────────────────────────────────────
function getBopfArchetype() {
  try {
    var raw = localStorage.getItem('bopf_archetype');
    if (!raw) return null;
    var data = JSON.parse(raw);
    if (Date.now() - (data.saved_at || 0) > 30 * 24 * 60 * 60 * 1000) {
      localStorage.removeItem('bopf_archetype');
      return null;
    }
    return data;
  } catch(e) { return null; }
}

function buildArchetypeContext(archetype) {
  if (!archetype) return null;
  var budgetLabels = { low:'under AED 2,000', mid:'AED 2,000-5,000', high:'AED 5,000-10,000', luxury:'AED 10,000+' };
  var occasionLabels = { everyday:'everyday use', work:'work', evening:'evening occasions', weekend:'weekends' };
  var collectorLabels = { first:'looking for their first luxury bag', adding:'adding to their collection', replacing:'replacing a beloved piece', gift:'buying a gift for someone special' };
  return [
    'Style archetype: ' + archetype.name,
    'Traits: ' + (archetype.traits || []).join(', '),
    archetype.brand && archetype.brand !== 'any' ? 'Preferred brand: ' + archetype.brand : 'Open to any brand',
    archetype.budget    ? 'Budget: '   + (budgetLabels[archetype.budget]       || archetype.budget)    : '',
    archetype.occasion  ? 'Occasion: ' + (occasionLabels[archetype.occasion]   || archetype.occasion)  : '',
    archetype.collector ? 'Context: '  + (collectorLabels[archetype.collector] || archetype.collector) : '',
    archetype.top_match ? 'Quiz top match: ' + archetype.top_match : '',
  ].filter(Boolean).join('\n');
}

// ── SYSTEM PROMPT ─────────────────────────────────────────────────────
var SYSTEM = 'You are Zara, a personal shopping concierge for BOPF (Business of Preloved Fashion) \u2014 a luxury preloved boutique in Dubai founded by Hadiza and Ify. You speak like a warm, knowledgeable friend who happens to know everything about luxury fashion. Not stiff, not corporate \u2014 natural, conversational, like a WhatsApp message from someone who really knows their stuff.\n\nYou help customers find authenticated preloved pieces from Chanel, Hermes, Dior, Gucci, Louis Vuitton, Cartier, Bottega Veneta, Fendi, Balenciaga and more.\n\nKey facts:\n- Every piece authenticated via Entrupy (99.1% accuracy), certificate included\n- Ships globally via DHL, 3-5 business days\n- WhatsApp: +971 58 566 9311\n- BNPL available at checkout\n- Returns accepted\n- To sell/consign: WhatsApp the team with photos\n\nWhen INVENTORY is provided, reference specific pieces naturally in your response \u2014 mention the title and price conversationally. If inventory is empty, acknowledge you do not have it right now but offer to notify them.\n\nKeep responses concise \u2014 2-4 sentences max. Never use bullet points. Sound like a person, not a chatbot. Respond to whatever the customer actually said, even if it is just "hi" or "yes" or "hmm". Always end with something that moves the conversation forward.';

// ── CSS ───────────────────────────────────────────────────────────────
var style = document.createElement('style');
style.textContent = ''
+'@import url("https://cdn.jsdelivr.net/npm/@fontsource/fraunces@5.0.20/400.css");'
+'@import url("https://cdn.jsdelivr.net/npm/@fontsource/fraunces@5.0.20/500.css");'
+'@import url("https://cdn.jsdelivr.net/npm/@fontsource/fraunces@5.0.20/400-italic.css");'
+'@import url("https://cdn.jsdelivr.net/npm/@fontsource/caveat@5.0.20/500.css");'
+':root{--a:#d3b2a1;--adk:#be9b89;--adim:rgba(211,178,161,.12);--mu:#9a9190;--mlt:#c4bfbc;--w:#fff;--cr:#faf8f6;--cr2:#f4efec;--bd:#ece6e2;--bdk:#ddd6d1;--tx:#1e1815;--gn:#5a9970;--fn:"proxima-nova",system-ui,sans-serif;--fd:"Fraunces",Georgia,serif}'
+'#bopf-bb{position:fixed;bottom:28px;left:28px;width:60px;height:60px;background:var(--a);border:none;border-radius:50%;cursor:pointer;z-index:9999;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 16px rgba(211,178,161,.35),0 1px 4px rgba(0,0,0,.08);transition:transform .25s cubic-bezier(.34,1.56,.64,1),box-shadow .25s,opacity .25s;-webkit-tap-highlight-color:transparent;touch-action:manipulation;animation:bopf-entrance .6s cubic-bezier(.34,1.56,.64,1) both}'
+'@keyframes bopf-entrance{from{transform:scale(0);opacity:0}to{transform:scale(1);opacity:1}}'
+'#bopf-bb:hover{transform:scale(1.06);box-shadow:0 4px 24px rgba(211,178,161,.45)}'
+'#bopf-bb:active{transform:scale(.95)}'
+'#bopf-badge{position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;padding:0 4px;background:#e05252;border-radius:10px;border:2.5px solid #fff;display:flex;align-items:center;justify-content:center;font-family:var(--fn);font-size:10px;font-weight:700;color:#fff;line-height:1;pointer-events:none;z-index:1;animation:bopf-entrance .4s .8s cubic-bezier(.34,1.56,.64,1) both}'
+'#bopf-bb.open #bopf-badge{display:none}'
+'#bopf-bb:not(.open)::before{content:"";position:absolute;inset:3px;border-radius:50%;border:1.5px solid transparent;border-top-color:rgba(255,255,255,0.55);border-right-color:rgba(255,255,255,0.2);animation:bopf-glisten 3s ease-in-out infinite;pointer-events:none}'
+'#bopf-bb.open{opacity:0!important;pointer-events:none!important;transform:scale(0.85)!important}'
+'@keyframes bopf-pulse{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(.7);opacity:.5}}'
+'@keyframes bopf-glisten{0%,100%{opacity:0;transform:rotate(-20deg)}30%,70%{opacity:1}50%{transform:rotate(20deg)}}'
+'@keyframes bopf-ring{0%{transform:scale(1);opacity:.7}100%{transform:scale(1.5);opacity:0}}'
+'@keyframes chip-in{from{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}'
+'@keyframes wa-slide{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}'
+'#bopf-pn{position:fixed;bottom:100px;left:28px;width:420px;height:564px;max-height:calc(100vh - 140px);background:var(--cr);border:0.5px solid var(--bd);border-radius:18px;z-index:9998;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 4px 32px rgba(42,33,24,.1),0 1px 8px rgba(42,33,24,.06);transform:translateY(14px) scale(.97);transform-origin:bottom left;opacity:0;pointer-events:none;transition:transform .38s cubic-bezier(.16,1,.3,1),opacity .25s}'
+'#bopf-pn.open{transform:translateY(0) scale(1);opacity:1;pointer-events:all}'
+'@media(max-width:540px){'
+'#bopf-bb{bottom:calc(20px + env(safe-area-inset-bottom));left:20px;width:60px;height:60px}'
+'#bopf-pn{position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;max-height:100%;border-radius:0;border:none;transform-origin:bottom center;transform:translateY(100%);z-index:2147483647}'
+'#bopf-pn.open{transform:translateY(0)}'
+'}'
+'#bopf-handle{display:none;justify-content:center;padding:10px 0 4px;cursor:grab;flex-shrink:0;touch-action:none;background:var(--w)}'
+'#bopf-hbar{width:36px;height:3px;background:var(--a);opacity:.3;border-radius:2px}'
+'@media(max-width:540px){#bopf-handle{display:flex}}'
+'.b-hdr{padding:12px 16px 10px;border-bottom:0.5px solid var(--bd);display:flex;align-items:center;gap:9px;flex-shrink:0;background:var(--w)}'
+'.b-hdr img{height:19px;object-fit:contain;opacity:.9}'
+'.b-hdiv{width:0.5px;height:15px;background:var(--bd)}'
+'.b-ht{font-family:var(--fd);font-style:italic;font-size:14px;font-weight:400;letter-spacing:.005em;color:var(--tx)}'
+'.b-hs{font-family:var(--fn);font-size:8px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;color:var(--mu);margin-top:2px}'
+'.b-hdot{margin-left:auto;display:flex;align-items:center;gap:4px;font-family:var(--fn);font-size:7.5px;letter-spacing:.1em;text-transform:uppercase;color:var(--mlt)}'
+'.b-hdot::before{content:"";width:5px;height:5px;border-radius:50%;background:#e05252;animation:bopf-pulse 2.5s ease-in-out infinite}'
+'.b-hclose{width:28px;height:28px;border-radius:50%;background:transparent;border:1.5px solid var(--a);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--a);font-size:16px;font-weight:400;line-height:1;margin-left:6px;flex-shrink:0;transition:background .15s,color .15s;-webkit-tap-highlight-color:transparent}'
+'.b-hclose:hover{background:var(--bd)}'
+'.b-msgs{flex:1;overflow-y:auto;padding:14px 14px 8px;display:flex;flex-direction:column;gap:12px;background:var(--cr);scrollbar-width:thin;scrollbar-color:var(--bd) transparent;overscroll-behavior:contain}'
+'.b-msgs::-webkit-scrollbar{width:3px}.b-msgs::-webkit-scrollbar-thumb{background:var(--bd)}'
+'.b-msg{display:flex;gap:8px;animation:b-in .35s cubic-bezier(.16,1,.3,1) both}.b-msg.user{flex-direction:row-reverse}'
+'.b-msgs .b-msg:nth-child(1){animation-delay:.05s}.b-msgs .b-msg:nth-child(2){animation-delay:.18s}.b-msgs .b-msg:nth-child(3){animation-delay:.31s}'
+'@keyframes b-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}'
+'.b-av{width:28px;height:28px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;margin-top:2px;overflow:hidden}'
+'.b-av.ai{background:var(--w);border:0.5px solid var(--bd);padding:4px}.b-av.ai img{width:100%;height:100%;object-fit:contain}'
+'.b-av.u{background:var(--a);font-family:var(--fn);font-size:9px;font-weight:500;color:#fff}'
+'.b-bbl{max-width:82%;padding:12px 15px;font-family:var(--fn);font-size:14px;line-height:1.7;font-weight:300;overflow-wrap:anywhere;word-break:break-word}'
+'.b-msg.ai .b-bbl{background:var(--w);border:0.5px solid var(--bd);border-left:2px solid var(--a);color:var(--tx);border-radius:2px 14px 14px 14px}'
+'.b-msg.user .b-bbl{background:var(--a);color:#fff;border-radius:14px 2px 14px 14px}'
+'.b-card{background:var(--w);border:0.5px solid var(--bd);border-radius:12px;margin-top:8px;overflow:hidden;display:flex;transition:transform .22s cubic-bezier(.34,1.56,.64,1),box-shadow .22s;cursor:pointer;text-decoration:none;animation:b-in .35s cubic-bezier(.16,1,.3,1) both}'
+'.b-card:hover{transform:translateY(-3px) scale(1.01);box-shadow:0 6px 20px rgba(211,178,161,.15)}'
+'.b-card img{width:72px;height:72px;object-fit:cover;flex-shrink:0}'
+'.b-ci{padding:9px 11px;flex:1;min-width:0;border-left:2px solid var(--a)}'
+'.b-cb{font-family:var(--fn);font-size:7.5px;letter-spacing:.2em;text-transform:uppercase;color:var(--a);margin-bottom:2px}'
+'.b-ct{font-family:var(--fn);font-size:11.5px;color:var(--tx);font-weight:400;margin-bottom:4px;line-height:1.35;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
+'.b-cf{display:flex;align-items:center;justify-content:space-between}'
+'.b-cp{font-family:var(--fn);font-size:11.5px;color:var(--tx);font-weight:500}'
+'.b-cl{font-family:var(--fn);font-size:8px;letter-spacing:.12em;text-transform:uppercase;color:var(--a)}'
+'.b-typing{display:flex;align-items:center;gap:5px;padding:12px 15px;background:var(--w);border:0.5px solid var(--bd);border-left:2px solid var(--a);width:fit-content;border-radius:2px 14px 14px 14px}'
+'.b-typing span{width:4px;height:4px;border-radius:50%;background:var(--a);animation:b-bounce 1.4s ease-in-out infinite}'
+'.b-typing span:nth-child(2){animation-delay:.2s}.b-typing span:nth-child(3){animation-delay:.4s}'
+'@keyframes b-bounce{0%,60%,100%{transform:translateY(0) scale(1);opacity:.3}30%{transform:translateY(-6px) scale(1.2);opacity:1}}'
+'.b-wa{display:inline-flex;align-items:center;gap:7px;margin-top:10px;padding:9px 14px;background:#25D366;color:#fff;border-radius:8px;font-family:var(--fn);font-size:12px;font-weight:500;text-decoration:none;min-height:40px;transition:background .15s}'
+'.b-wa:hover{background:#1ebe5d}'
+'.b-maps{display:inline-flex;align-items:center;gap:7px;margin-top:10px;padding:9px 14px;background:var(--a);color:#fff;border-radius:8px;font-family:var(--fn);font-size:12px;font-weight:500;text-decoration:none;min-height:40px;transition:background .15s}'
+'.b-maps:hover{background:var(--adk)}'
+'.b-sugs{display:flex;gap:6px;padding:7px 14px 10px;overflow-x:auto;scrollbar-width:none;background:var(--w);border-top:0.5px solid var(--bd);flex-shrink:0}'
+'.b-sugs::-webkit-scrollbar{display:none}'
+'.b-sug{padding:0 13px;height:30px;border:0.5px solid var(--bdk);background:var(--cr2);color:var(--mu);font-family:var(--fn);font-size:9px;letter-spacing:.08em;cursor:pointer;transition:all .18s;text-transform:uppercase;border-radius:20px;display:flex;align-items:center;white-space:nowrap;flex-shrink:0;-webkit-tap-highlight-color:transparent}'
+'.b-sug:hover{border-color:var(--a);color:var(--a);background:var(--adim)}'
+'.b-inparea{padding:10px 14px 13px;border-top:0.5px solid var(--bd);flex-shrink:0;background:var(--w)}'
+'.b-inprow{display:flex;gap:7px;align-items:flex-end}'
+'#bopf-img-btn{width:40px;height:40px;background:var(--cr2);border:0.5px solid var(--bd);border-radius:10px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .15s;-webkit-tap-highlight-color:transparent}'
+'#bopf-img-btn:hover{border-color:var(--a);background:var(--adim)}'
+'#bopf-img-btn svg{width:16px;height:16px;fill:var(--mu)}'
+'#bopf-img-input{display:none}'
+'#bopf-inp{flex:1;background:var(--cr2);border:0.5px solid var(--bd);color:var(--tx);font-family:var(--fn);font-weight:300;font-size:16px;line-height:1.5;padding:10px 13px;resize:none;outline:none;border-radius:10px;min-height:40px;max-height:110px;transition:border-color .2s,box-shadow .2s;-webkit-appearance:none}'
+'#bopf-inp:focus{border-color:var(--a);box-shadow:0 0 0 3px rgba(211,178,161,.12)}'
+'#bopf-inp::placeholder{color:var(--mlt);font-size:13px}'
+'#bopf-send{width:40px;height:40px;background:var(--a);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:10px;transition:background .15s,transform .1s,box-shadow .15s;box-shadow:0 2px 8px rgba(211,178,161,.3);-webkit-tap-highlight-color:transparent}'
+'#bopf-send:hover{background:var(--adk);box-shadow:0 3px 12px rgba(211,178,161,.4)}'
+'#bopf-send:active{transform:scale(.92);box-shadow:none}'
+'#bopf-send:disabled{background:var(--bdk);box-shadow:none;cursor:not-allowed}'
+'#bopf-send svg{width:14px;height:14px;fill:#fff;transition:transform .12s}'
+'#bopf-send:active svg{transform:translateX(2px) translateY(-2px) scale(.88)}'
+'#bopf-bb.bopf-proactive::after{content:"";position:absolute;inset:-5px;border-radius:50%;border:1.5px solid var(--a);animation:bopf-ring .9s ease-out 2}'
+'.b-footer{text-align:center;margin-top:7px;font-family:var(--fn);font-size:7.5px;letter-spacing:.1em;text-transform:uppercase;color:var(--mlt)}'
+'#bopf-bd{display:none;position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:9997;opacity:0;transition:opacity .25s}'
+'@media(max-width:540px){#bopf-bd{display:block;pointer-events:none}}'
+'#bopf-bd.open{opacity:1;pointer-events:all}'
+'#bopf-nudge{position:fixed;bottom:100px;left:28px;max-width:240px;background:var(--w);border:0.5px solid var(--bd);border-left:2px solid var(--a);border-radius:2px 12px 12px 12px;padding:10px 14px;font-family:var(--fn);font-size:12px;line-height:1.55;color:var(--tx);box-shadow:0 4px 20px rgba(42,33,24,.1);z-index:9998;opacity:0;transform:translateY(8px) scale(.96);pointer-events:none;transition:opacity .4s cubic-bezier(.16,1,.3,1),transform .4s cubic-bezier(.16,1,.3,1)}'
+'#bopf-nudge.show{opacity:1;transform:translateY(0) scale(1);pointer-events:all}'
+'#bopf-nudge .b-ndismiss{position:absolute;top:6px;right:8px;width:18px;height:18px;border:none;background:none;cursor:pointer;color:var(--mlt);font-size:14px;line-height:1;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:color .15s}'
+'#bopf-nudge .b-ndismiss:hover{color:var(--a)}'
+'#bopf-nudge .b-ncta{display:inline-block;margin-top:6px;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:var(--a);cursor:pointer;font-weight:500;transition:opacity .15s}'
+'#bopf-nudge .b-ncta:hover{opacity:.7}'
+'@keyframes bopf-gentle-bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}'
+'#bopf-bb.bopf-bounce{animation:bopf-gentle-bounce .5s cubic-bezier(.34,1.56,.64,1)}'
+'@media(max-width:540px){#bopf-nudge{bottom:calc(92px + env(safe-area-inset-bottom));left:20px;max-width:220px}}'
// ── HOME STRIP (returning visitors) ───────────────────────────────
+'#bopf-home-strip{font-family:var(--fn);color:var(--tx);max-width:1240px;margin:0 auto;padding:0 16px}'
+'#bopf-home-strip .hs-strip{background:#fff;border:0.5px solid var(--bd);border-left:2px solid var(--a);border-radius:2px 10px 10px 10px;padding:16px 18px 18px;animation:hs-in .4s cubic-bezier(.16,1,.3,1) both}'
+'@keyframes hs-in{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}'
+'#bopf-home-strip .hs-hdr{display:flex;align-items:center;gap:10px;margin-bottom:14px}'
+'#bopf-home-strip .hs-av{width:28px;height:28px;border-radius:50%;background:#fff;border:0.5px solid var(--bd);display:flex;align-items:center;justify-content:center;padding:4px;flex-shrink:0;overflow:hidden}'
+'#bopf-home-strip .hs-av img{width:100%;height:100%;object-fit:contain;display:block}'
+'#bopf-home-strip .hs-title-main{font-family:Georgia,"Playfair Display",serif;font-size:17px;color:var(--tx);font-weight:400;line-height:1.3;flex:1}'
+'#bopf-home-strip .hs-meta{font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--mu);white-space:nowrap}'
+'#bopf-home-strip .hs-dismiss{width:24px;height:24px;background:transparent;border:none;color:var(--mlt);font-size:18px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:color .15s,background .15s;flex-shrink:0;-webkit-tap-highlight-color:transparent}'
+'#bopf-home-strip .hs-dismiss:hover{color:var(--tx);background:var(--cr2)}'
+'#bopf-home-strip .hs-cards{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}'
+'#bopf-home-strip .hs-cards.hs-cart-2{display:flex;flex-wrap:wrap;gap:12px;grid-template-columns:none}'
+'#bopf-home-strip .hs-cards.hs-cart-2 .hs-card{flex:1 1 220px;max-width:280px;min-width:200px}'
+'#bopf-home-strip .hs-card{background:#fff;border:0.5px solid var(--bd);border-radius:6px;overflow:hidden;cursor:pointer;transition:transform .2s cubic-bezier(.34,1.56,.64,1),border-color .15s,box-shadow .2s;text-decoration:none;color:inherit;display:flex;flex-direction:column}'
+'#bopf-home-strip .hs-card:hover{transform:translateY(-2px);border-color:var(--a);box-shadow:0 4px 16px rgba(211,178,161,.18)}'
+'#bopf-home-strip .hs-card.is-sold{cursor:default;opacity:.75}'
+'#bopf-home-strip .hs-card.is-sold:hover{transform:none;border-color:var(--bd);box-shadow:none}'
+'#bopf-home-strip .hs-card-img{aspect-ratio:1;background:var(--cr2);display:flex;align-items:center;justify-content:center;position:relative;border-bottom:0.5px solid var(--bd);overflow:hidden}'
+'#bopf-home-strip .hs-card-img img{width:100%;height:100%;object-fit:cover;display:block}'
+'#bopf-home-strip .hs-mono{font-family:Georgia,"Playfair Display",serif;font-size:54px;color:var(--mlt);font-style:italic}'
+'#bopf-home-strip .hs-sold-badge{position:absolute;top:8px;left:8px;background:rgba(255,255,255,.96);border:0.5px solid var(--bdk);color:var(--tx);font-size:9px;letter-spacing:.12em;text-transform:uppercase;padding:3px 7px;border-radius:2px;font-weight:500}'
+'#bopf-home-strip .hs-cart-pin{position:absolute;top:8px;right:8px;background:var(--a);color:#fff;font-size:9px;letter-spacing:.12em;text-transform:uppercase;padding:3px 7px;border-radius:2px;font-weight:500}'
+'#bopf-home-strip .hs-card-body{padding:10px 12px 12px;flex:1;display:flex;flex-direction:column;gap:4px}'
+'#bopf-home-strip .hs-brand{font-size:8px;letter-spacing:.2em;text-transform:uppercase;color:var(--adk);font-weight:500}'
+'#bopf-home-strip .hs-title{font-size:12px;color:var(--tx);line-height:1.35;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;min-height:32px}'
+'#bopf-home-strip .hs-price{font-size:12px;color:var(--tx);font-weight:500;margin-top:auto}'
+'#bopf-home-strip .hs-price.hs-sold-text{color:var(--mu);font-weight:400;font-style:italic}'
+'#bopf-home-strip .hs-footer{margin-top:14px;padding-top:12px;border-top:0.5px solid var(--bd);display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap}'
+'#bopf-home-strip .hs-total{font-size:13px;color:var(--tx)}'
+'#bopf-home-strip .hs-total strong{font-weight:500}'
+'#bopf-home-strip .hs-bnpl{font-size:11px;color:var(--mu);line-height:1.4}'
+'#bopf-home-strip .hs-cta{font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--adk);font-weight:500;text-decoration:none;white-space:nowrap;transition:color .15s}'
+'#bopf-home-strip .hs-cta:hover{color:var(--tx)}'
+'#bopf-home-strip .hs-subnote{margin-top:12px;font-size:11px;color:var(--mu);line-height:1.45;font-style:italic}'
+'@media(max-width:768px){#bopf-home-strip .hs-cards{grid-template-columns:repeat(2,1fr)}#bopf-home-strip .hs-cards.hs-cart-2{grid-template-columns:repeat(2,1fr)}#bopf-home-strip .hs-title-main{font-size:15px}#bopf-home-strip .hs-footer{flex-direction:column;align-items:flex-start}}'
+'@media(max-width:420px){#bopf-home-strip .hs-cards{grid-template-columns:repeat(2,1fr)}#bopf-home-strip .hs-strip{padding:14px 14px 16px}}'
// ── POP UP BANNER (evergreen Pop Up Series invite) ────────────────
// Renders BELOW the home strip on the home page. Carries the Pop Up
// page aesthetic: terracotta thread, grain overlay, Caveat signature.
// Fonts are imported at the top of this style block (Fraunces + Caveat
// via Fontsource on jsdelivr). @import must appear before any other
// CSS rule per spec; putting it here at the bottom would be silently
// ignored by every browser.
+'#bopf-popup-banner{font-family:var(--fn);color:var(--tx);max-width:1240px;margin:14px auto 0;padding:0 16px}'
+'#bopf-popup-banner .pb-banner{position:relative;background:#F7F1E7;border:0.5px solid rgba(43,31,26,0.14);border-radius:4px;padding:22px 28px 24px;display:flex;align-items:center;justify-content:space-between;gap:22px;cursor:pointer;overflow:hidden;text-decoration:none;color:inherit;transition:box-shadow .22s ease,transform .22s cubic-bezier(.34,1.56,.64,1),border-color .22s ease;animation:pb-in .4s cubic-bezier(.16,1,.3,1) both}'
+'#bopf-popup-banner .pb-banner:hover{transform:translateY(-1px);border-color:rgba(184,104,66,0.35);box-shadow:0 4px 18px rgba(184,104,66,.10)}'
+'@keyframes pb-in{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}'
+'#bopf-popup-banner .pb-banner::before{content:"";position:absolute;inset:0;background-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'120\' height=\'120\'><filter id=\'n\'><feTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'2\' stitchTiles=\'stitch\'/><feColorMatrix values=\'0 0 0 0 0.17  0 0 0 0 0.12  0 0 0 0 0.10  0 0 0 0.04 0\'/></filter><rect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/></svg>");opacity:0.35;mix-blend-mode:multiply;pointer-events:none}'
+'#bopf-popup-banner .pb-thread{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:0;overflow:visible}'
+'#bopf-popup-banner .pb-thread path{fill:none;stroke:#B86842;stroke-width:1;stroke-linecap:round;opacity:0.3;stroke-dasharray:1400;stroke-dashoffset:1400;animation:pb-thread 2.4s cubic-bezier(.22,.8,.28,1) .2s forwards;filter:drop-shadow(0 0 3px rgba(184,104,66,0.12))}'
+'@keyframes pb-thread{to{stroke-dashoffset:0}}'
+'#bopf-popup-banner .pb-left,#bopf-popup-banner .pb-right{position:relative;z-index:1}'
+'#bopf-popup-banner .pb-left{display:flex;flex-direction:column;gap:6px;flex:1;min-width:0}'
+'#bopf-popup-banner .pb-eyebrow{font-family:"Manrope",-apple-system,sans-serif;font-size:10px;letter-spacing:.3em;text-transform:uppercase;color:#8A7868;font-weight:500;display:flex;align-items:center;gap:10px}'
+'#bopf-popup-banner .pb-eyebrow::before{content:"";width:22px;height:1px;background:#B86842}'
+'#bopf-popup-banner .pb-title{font-family:"Fraunces",Georgia,serif;font-weight:300;font-size:20px;line-height:1.3;color:#2B1F1A;letter-spacing:-0.005em;margin:0;display:flex;align-items:baseline;gap:10px;flex-wrap:wrap}'
+'#bopf-popup-banner .pb-sig-wrap{display:inline-flex;flex-direction:column;align-items:flex-start;gap:2px;line-height:1}'
+'#bopf-popup-banner .pb-address{font-family:"Fraunces",Georgia,serif;font-style:italic;font-weight:400;font-size:12px;line-height:1.4;color:#8A7868;margin-top:8px;letter-spacing:0.005em}'
+'#bopf-popup-banner .pb-address::before{content:"";display:inline-block;width:10px;height:1px;background:#B86842;opacity:0.5;vertical-align:middle;margin-right:8px;transform:translateY(-1px)}'
+'#bopf-popup-banner .pb-sig{font-family:"Caveat","Brush Script MT",cursive;font-weight:500;font-size:28px;line-height:1;color:#B86842;display:inline-block;transform:translateY(3px);padding:0 4px 2px 0;clip-path:inset(0 100% 0 -4px);-webkit-clip-path:inset(0 100% 0 -4px);animation:pb-write 2.1s cubic-bezier(.22,.8,.28,1) .5s forwards}'
+'@keyframes pb-write{to{clip-path:inset(0 0% 0 -4px);-webkit-clip-path:inset(0 0% 0 -4px)}}'
+'#bopf-popup-banner .pb-flourish{width:72px;height:10px;color:#B86842;opacity:0.5}'
+'#bopf-popup-banner .pb-flourish path{fill:none;stroke:currentColor;stroke-width:1.2;stroke-linecap:round;stroke-dasharray:140;stroke-dashoffset:140;animation:pb-flour 1.2s cubic-bezier(.22,.8,.28,1) 2.2s forwards}'
+'@keyframes pb-flour{to{stroke-dashoffset:0}}'
+'#bopf-popup-banner .pb-right{display:flex;align-items:center;gap:18px;flex-shrink:0}'
+'#bopf-popup-banner .pb-date{text-align:right}'
+'#bopf-popup-banner .pb-date-label{font-family:"Manrope",-apple-system,sans-serif;font-size:9px;letter-spacing:.25em;text-transform:uppercase;color:#8A7868;margin-bottom:3px}'
+'#bopf-popup-banner .pb-date-main{font-family:"Fraunces",Georgia,serif;font-weight:400;font-size:14px;color:#2B1F1A;letter-spacing:-0.005em}'
+'#bopf-popup-banner .pb-countdown{font-family:"Fraunces",Georgia,serif;font-style:italic;font-size:11px;color:#B86842;margin-top:2px}'
+'#bopf-popup-banner .pb-arrow{width:38px;height:38px;border:1px solid #2B1F1A;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#2B1F1A;transition:background .3s ease,color .3s ease,transform .3s ease;flex-shrink:0}'
+'#bopf-popup-banner .pb-banner:hover .pb-arrow{background:#2B1F1A;color:#F7F1E7;transform:translateX(3px)}'
+'#bopf-popup-banner .pb-dismiss{position:absolute;top:6px;right:10px;width:22px;height:22px;background:transparent;border:none;color:rgba(43,31,26,0.3);font-size:16px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:color .15s,background .15s;z-index:2;-webkit-tap-highlight-color:transparent}'
+'#bopf-popup-banner .pb-dismiss:hover{color:#2B1F1A;background:rgba(255,255,255,0.5)}'
+'@media(max-width:720px){#bopf-popup-banner .pb-banner{flex-direction:column;align-items:flex-start;gap:16px;padding:18px 20px 20px}#bopf-popup-banner .pb-right{align-self:stretch;justify-content:space-between;width:100%}#bopf-popup-banner .pb-title{font-size:17px}#bopf-popup-banner .pb-sig{font-size:24px}}'
+'#bopf-promo-banner{font-family:var(--fn);position:sticky;top:0;z-index:100;width:100%;background:transparent;margin:14px 0 0;padding:0;transition:padding .35s cubic-bezier(.22,.8,.28,1),margin .35s}'
+'#bopf-promo-banner.is-collapsed{margin-top:0}'
+'#bopf-promo-banner .prm-wrap{max-width:1240px;margin:0 auto;padding:0 16px;transition:padding .35s cubic-bezier(.22,.8,.28,1)}'
+'#bopf-promo-banner.is-collapsed .prm-wrap{padding:0}'
+'#bopf-promo-banner .prm{position:relative;background:#B86842;border-radius:14px;padding:22px 28px;display:grid;grid-template-columns:1fr auto auto;gap:28px;align-items:center;overflow:hidden;text-decoration:none;color:inherit;cursor:pointer;animation:prm-in .55s cubic-bezier(.16,1,.3,1) both;transition:padding .35s cubic-bezier(.22,.8,.28,1),border-radius .35s cubic-bezier(.22,.8,.28,1),background .25s ease;-webkit-tap-highlight-color:transparent}'
+'#bopf-promo-banner .prm:hover{background:#A55B39}'
+'#bopf-promo-banner.is-collapsed .prm{padding:8px 28px;border-radius:0;grid-template-columns:auto auto 1fr auto auto auto;gap:16px}'
+'@keyframes prm-in{from{opacity:0;transform:translateY(-12px)}to{opacity:1;transform:translateY(0)}}'
+'#bopf-promo-banner .prm::before{content:"";position:absolute;top:0;bottom:0;left:-60%;width:50%;background:linear-gradient(110deg,transparent 30%,rgba(251,243,238,.14) 50%,transparent 70%);animation:prm-shine 7s ease-in-out infinite;pointer-events:none}'
+'@keyframes prm-shine{0%{left:-60%}55%,100%{left:160%}}'
+'#bopf-promo-banner .prm:hover::before{animation-duration:1.6s}'
+'#bopf-promo-banner .prm-text{position:relative;z-index:1;min-width:0}'
+'#bopf-promo-banner .prm-eyebrow{display:flex;align-items:center;gap:10px;font-family:"Manrope",-apple-system,sans-serif;font-size:10px;letter-spacing:.3em;text-transform:uppercase;color:#F7D8C8;font-weight:500;margin-bottom:6px}'
+'#bopf-promo-banner.is-collapsed .prm-eyebrow{display:none}'
+'#bopf-promo-banner .prm-flourish-top{width:30px;height:9px;opacity:.65;flex-shrink:0}'
+'#bopf-promo-banner .prm-flourish-top path{fill:none;stroke:#FBF3EE;stroke-width:1.4;stroke-linecap:round;animation:prm-float 4s ease-in-out infinite}'
+'@keyframes prm-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-1.5px)}}'
+'#bopf-promo-banner .prm-name{font-family:"Fraunces",Georgia,serif;font-style:italic;font-weight:300;font-size:22px;line-height:1.2;color:#FBF3EE;margin-bottom:4px;letter-spacing:.002em;transition:font-size .35s,margin .35s}'
+'#bopf-promo-banner.is-collapsed .prm-name{font-size:14px;margin-bottom:0}'
+'#bopf-promo-banner .prm-sub-wrap{position:relative;display:inline-block;max-width:100%;transition:opacity .25s,height .35s,margin .35s}'
+'#bopf-promo-banner.is-collapsed .prm-sub-wrap{display:none}'
+'#bopf-promo-banner .prm-sub{font-family:"Fraunces",Georgia,serif;font-style:italic;font-weight:300;font-size:13.5px;line-height:1.35;color:#FBF3EE;opacity:.92}'
+'#bopf-promo-banner .prm-sub-underline{position:absolute;left:-2px;right:-2px;bottom:-5px;width:calc(100% + 4px);height:6px;pointer-events:none;overflow:visible}'
+'#bopf-promo-banner .prm-sub-underline path{fill:none;stroke:#FBF3EE;stroke-width:1.6;stroke-linecap:round;stroke-dasharray:100;stroke-dashoffset:100;animation:prm-underline-loop 11s cubic-bezier(.22,.8,.28,1) .4s infinite}'
+'@keyframes prm-underline-loop{0%{stroke-dashoffset:100}12%{stroke-dashoffset:0}72%{stroke-dashoffset:0}93%{stroke-dashoffset:-100}100%{stroke-dashoffset:-100}}'
+'#bopf-promo-banner .prm-discount-wrap{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;padding:0 8px;transition:opacity .25s,padding .35s}'
+'#bopf-promo-banner.is-collapsed .prm-discount-wrap{display:none}'
+'#bopf-promo-banner .prm-discount{font-family:"Fraunces",Georgia,serif;font-weight:400;font-style:italic;font-size:30px;line-height:1;color:#FBF3EE;letter-spacing:-0.01em;white-space:nowrap;animation:prm-discount-pulse 3.4s ease-in-out infinite;position:relative;z-index:2}'
+'@keyframes prm-discount-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}'
+'#bopf-promo-banner .prm-diag-slash{position:absolute;top:50%;left:50%;width:150px;height:42px;transform:translate(-50%,-50%) rotate(-22deg);pointer-events:none;z-index:1;opacity:.55}'
+'#bopf-promo-banner .prm-diag-slash path{fill:none;stroke:#FBF3EE;stroke-width:1.6;stroke-linecap:round;stroke-dasharray:200;stroke-dashoffset:200;animation:prm-slash-draw 1.2s cubic-bezier(.22,.8,.28,1) .8s forwards}'
+'@keyframes prm-slash-draw{to{stroke-dashoffset:0}}'
+'#bopf-promo-banner .prm-actions{position:relative;z-index:1;display:flex;align-items:center;gap:14px;transition:gap .35s}'
+'#bopf-promo-banner.is-collapsed .prm-actions{gap:10px}'
+'#bopf-promo-banner .prm-code{display:inline-flex;align-items:center;gap:8px;padding:9px 16px 9px 14px;border:1px dashed #FBF3EE;border-radius:999px;color:#FBF3EE;background:transparent;font-family:"SFMono-Regular",Consolas,monospace;font-size:12px;letter-spacing:.15em;font-weight:500;cursor:pointer;position:relative;z-index:2;transition:background .2s,padding .35s,font-size .35s;-webkit-tap-highlight-color:transparent}'
+'#bopf-promo-banner .prm-code:hover{background:rgba(251,243,238,.18)}'
+'#bopf-promo-banner.is-collapsed .prm-code{padding:4px 11px;font-size:10px}'
+'#bopf-promo-banner .prm-code.is-copied{animation:prm-copied .42s ease-out}'
+'@keyframes prm-copied{0%{transform:scale(1)}40%{transform:scale(1.08)}100%{transform:scale(1)}}'
+'#bopf-promo-banner .prm-code-icon{width:11px;height:11px;opacity:.7;flex-shrink:0}'
+'#bopf-promo-banner .prm-cta{position:relative;background:#FBF3EE;color:#B86842;font-family:"Manrope",-apple-system,sans-serif;font-size:12px;letter-spacing:.18em;text-transform:uppercase;font-weight:500;padding:10px 18px;border-radius:999px;display:inline-flex;align-items:center;gap:8px;transition:gap .25s,padding .35s,font-size .35s,background .25s}'
+'#bopf-promo-banner .prm:hover .prm-cta{background:#fff;gap:11px}'
+'#bopf-promo-banner.is-collapsed .prm-cta{padding:5px 14px;font-size:10px;gap:6px}'
+'#bopf-promo-banner .prm-cta .prm-arrow{width:13px;height:13px;animation:prm-arrow-bob 1.8s ease-in-out infinite}'
+'@keyframes prm-arrow-bob{0%,100%{transform:translateX(0)}50%{transform:translateX(3px)}}'
+'#bopf-promo-banner .prm-diag-flourish{position:absolute;bottom:-9px;right:-4px;width:70px;height:14px;transform:rotate(15deg);pointer-events:none;z-index:1;opacity:.5}'
+'#bopf-promo-banner .prm-diag-flourish path{fill:none;stroke:#FBF3EE;stroke-width:1.4;stroke-linecap:round;stroke-dasharray:100;stroke-dashoffset:100;animation:prm-flourish-draw 1s cubic-bezier(.22,.8,.28,1) 1.4s forwards}'
+'@keyframes prm-flourish-draw{to{stroke-dashoffset:0}}'
+'#bopf-promo-banner.is-collapsed .prm-diag-flourish,#bopf-promo-banner.is-collapsed .prm-diag-slash{display:none}'
+'#bopf-promo-banner .prm-dismiss{position:absolute;top:10px;right:12px;width:26px;height:26px;background:rgba(251,243,238,.08);border:0.5px solid rgba(251,243,238,.35);border-radius:50%;color:#FBF3EE;font-size:16px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;padding:0;font-family:inherit;transition:background .15s,transform .15s,top .35s,right .35s,width .35s,height .35s,font-size .35s;-webkit-tap-highlight-color:transparent}'
+'#bopf-promo-banner .prm-dismiss:hover{background:rgba(251,243,238,.22);transform:scale(1.08)}'
+'#bopf-promo-banner.is-collapsed .prm-dismiss{top:4px;right:8px;width:20px;height:20px;font-size:13px}'
+'@media(max-width:760px){'
+ '#bopf-promo-banner .prm-wrap{padding:0 12px}'
+ '#bopf-promo-banner .prm{grid-template-columns:1fr;gap:14px;padding:18px 20px 22px;border-radius:12px}'
+ '#bopf-promo-banner.is-collapsed .prm{grid-template-columns:auto 1fr auto;padding:7px 16px;gap:10px}'
+ '#bopf-promo-banner .prm-name{font-size:19px}'
+ '#bopf-promo-banner .prm-sub{font-size:12.5px}'
+ '#bopf-promo-banner .prm-discount{font-size:26px}'
+ '#bopf-promo-banner .prm-discount-wrap{display:inline-flex;align-self:flex-start;padding:0}'
+ '#bopf-promo-banner .prm-actions{justify-content:flex-start;flex-wrap:wrap}'
+ '#bopf-promo-banner .prm-diag-flourish{display:none}'
+ '#bopf-promo-banner .prm-diag-slash{width:130px;height:36px;transform:translate(-50%,-50%) rotate(-18deg)}'
+ '#bopf-promo-banner.is-collapsed .prm-name{font-size:13px}'
+ '#bopf-promo-banner.is-collapsed .prm-actions{display:none}'
+'}'
+'@media(max-width:420px){'
+ '#bopf-promo-banner .prm-name{font-size:17px}'
+ '#bopf-promo-banner .prm-discount{font-size:22px}'
+'}'
+'@media (prefers-reduced-motion:reduce){'
+ '#bopf-promo-banner .prm,'
+ '#bopf-promo-banner .prm-flourish-top path,'
+ '#bopf-promo-banner .prm-sub-underline path,'
+ '#bopf-promo-banner .prm-discount,'
+ '#bopf-promo-banner .prm-diag-slash path,'
+ '#bopf-promo-banner .prm-diag-flourish path,'
+ '#bopf-promo-banner .prm-cta .prm-arrow,'
+ '#bopf-promo-banner .prm::before{animation:none!important;stroke-dashoffset:0!important}'
+'}';
document.head.appendChild(style);

// ── HTML ──────────────────────────────────────────────────────────────
var SEND_SVG = '<svg viewBox="0 0 24 24"><path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/></svg>';
var CAM_SVG  = '<svg viewBox="0 0 24 24"><path d="M12 15.2A3.2 3.2 0 0 1 8.8 12 3.2 3.2 0 0 1 12 8.8 3.2 3.2 0 0 1 15.2 12 3.2 3.2 0 0 1 12 15.2M12 7a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5m0-7L8.5 3.5H5C3.89 3.5 3 4.39 3 5.5v13C3 19.61 3.89 20.5 5 20.5h14c1.11 0 2-.89 2-2v-13c0-1.11-.89-2-2-2h-3.5L12 0m0 2l2.04 2H19v13H5V4h4.96L12 2z"/></svg>';
var BELL_SVG = '<svg viewBox="0 0 24 24" style="width:26px;height:26px;fill:#fff"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>';
var LAUNCHER_CLOSE = '<span style="font-size:22px;font-weight:300;color:#fff;line-height:1">\u00d7</span>';

document.body.insertAdjacentHTML('beforeend',
  '<div id="bopf-bd" data-bopf-self="1"></div>'
  +'<div id="bopf-nudge" data-bopf-self="1"><button class="b-ndismiss">\u00d7</button><div id="bopf-nudge-text"></div><span class="b-ncta" id="bopf-nudge-cta">Chat with Zara</span></div>'
  +'<div id="bopf-bb" role="button" aria-label="BOPF Shopping Concierge" data-bopf-self="1">'
  +'<div id="bopf-badge">1</div>'
  +'<div id="bopf-bi">'+BELL_SVG+'</div>'
  +'</div>'
  +'<div id="bopf-pn" role="dialog" data-bopf-self="1">'
  +'<div id="bopf-handle"><div id="bopf-hbar"></div></div>'
  +'<div class="b-hdr">'
  +'<img src="'+LOGO+'" alt="BOPF" onerror="this.style.display=\'none\'">'
  +'<div class="b-hdiv"></div>'
  +'<svg viewBox="0 0 24 24" style="width:13px;height:13px;fill:var(--a);flex-shrink:0"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>'
  +'<div><div class="b-ht">Zara</div><div class="b-hs">Personal Concierge</div></div>'
  +'<div class="b-hdot">Zara is online</div>'
  +'<div class="b-hclose" id="bopf-hclose">\u00d7</div>'
  +'</div>'
  +'<div class="b-msgs" id="bopf-msgs"></div>'
  +'<div class="b-sugs" id="bopf-sugs"></div>'
  +'<div class="b-inparea">'
  +'<div class="b-inprow">'
  +'<input type="file" id="bopf-img-input" accept="image/*">'
  +'<button id="bopf-img-btn" title="Upload image to search">'+CAM_SVG+'</button>'
  +'<textarea id="bopf-inp" placeholder="Ask me anything..." rows="1" aria-label="Message BOPF concierge"></textarea>'
  +'<button id="bopf-send" aria-label="Send">'+SEND_SVG+'</button>'
  +'</div>'
  +'<div class="b-footer">BOPF Personal Concierge &middot; Powered by AI</div>'
  +'</div></div></div>'
);

// ── STATE ─────────────────────────────────────────────────────────────
var isOpen=false, isLoading=false, didGreet=false, history=[];
var MEM_KEY = 'bopf_mem_v10';
function memLoad(){ try{ return JSON.parse(localStorage.getItem(MEM_KEY))||{}; }catch(e){ return {}; } }
function memSave(u){ try{ var m=memLoad(); localStorage.setItem(MEM_KEY,JSON.stringify(Object.assign(m,u))); }catch(e){} }

// ── CUSTOMER PROFILE (elicited conversationally by Zara) ──────────────
// Lightweight taste/fit store keyed by this browser. Zara sees current
// values via the [Profile: ...] tag on every turn and may ask to fill
// in missing fields when it would narrow results. Saves happen only when
// the server echoes a [PROFILE_SAVE: field=value] signal in the reply,
// which the server strips before it reaches the customer.
var PROFILE_KEY = 'bopf_profile_v1';
function profileLoad() {
  try { return JSON.parse(localStorage.getItem(PROFILE_KEY)) || {}; }
  catch(e) { return {}; }
}
function profileSave(patch) {
  try {
    var p = profileLoad();
    Object.keys(patch).forEach(function(k) {
      var v = patch[k];
      if (v === null || v === '' || (Array.isArray(v) && !v.length)) delete p[k];
      else p[k] = v;
    });
    localStorage.setItem(PROFILE_KEY, JSON.stringify(p));
    return p;
  } catch(e) { return {}; }
}
function profileToContextTag() {
  var p = profileLoad();
  var parts = [];
  if (p.size_shoes)          parts.push('shoe size ' + p.size_shoes);
  if (p.size_clothing)       parts.push('clothing size ' + p.size_clothing);
  if (p.size_bag_preference) parts.push('prefers ' + p.size_bag_preference + ' bags');
  if (p.favourite_designers && p.favourite_designers.length)
    parts.push('loves ' + p.favourite_designers.slice(0, 3).join(', '));
  if (p.budget_band)         parts.push('budget ' + p.budget_band);
  if (p.avoid_designers && p.avoid_designers.length)
    parts.push('not into ' + p.avoid_designers.slice(0, 2).join(', '));
  return parts.length ? ' [Profile: ' + parts.join('; ') + ']' : '';
}
// Refine raw search query with profile-derived filters (e.g. size tag).
// No-ops if: no profile, magic query (__x__), or SKU lookup.
// Assumes products are tagged with Size_X format (e.g. Size_37, Size_M).
function refineQueryWithProfile(q) {
  var p = profileLoad();
  if (!p || !Object.keys(p).length || !q) return q;
  if (q.indexOf('__') === 0 || q.indexOf('sku:') === 0) return q;
  var isShoes    = /shoe|boot|heel|sneaker|sandal|loafer|mule|pump|flat/i.test(q);
  var isClothing = /dress|top|skirt|jacket|coat|trouser|blazer|shirt|sweater|knit/i.test(q);
  var extras = [];
  if (isShoes && p.size_shoes) extras.push('tag:Size_' + p.size_shoes);
  else if (isClothing && p.size_clothing) extras.push('tag:Size_' + p.size_clothing);
  return extras.length ? q + ' ' + extras.join(' ') : q;
}

// ── PAGE CONTEXT ──────────────────────────────────────────────────────
function getPageContext() {
  var path = window.location.pathname.toLowerCase();
  var title = document.title || '';
  var tl = title.toLowerCase();
  var type = path.indexOf('/products/') > -1 ? 'product'
           : path.indexOf('/collections/') > -1 ? 'collection'
           : path.indexOf('/cart') > -1 ? 'cart'
           : path.indexOf('/search') > -1 ? 'search'
           : 'home';
  var prod = null, prodPrice = null, prodBrand = null, prodImg = null;
  try {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product) {
      prod      = meta.product.title || null;
      prodPrice = meta.product.price ? 'Dhs. ' + (meta.product.price / 100).toLocaleString() : null;
      prodBrand = meta.product.vendor || null;
    }
  } catch(e) {}
  if (!prod && type === 'product') {
    prod = title.replace(/ [-\u2013] .*$/, '').trim();
    var priceEl = document.querySelector('.price, [class*="price"] .money, [class*="Price"]');
    if (priceEl) prodPrice = priceEl.textContent.trim().split('\n')[0].trim();
    var imgEl = document.querySelector('.product__media img, .product-single__photo img, [class*="product"] img');
    if (imgEl) prodImg = imgEl.src || null;
  }
  var brandList = ['hermes','chanel','dior','gucci','cartier','balenciaga','bottega','fendi','louis vuitton','prada','celine','valentino','loewe'];
  var brand = brandList.find(function(b){ return path.indexOf(b) > -1 || tl.indexOf(b) > -1; });
  if (!brand && prodBrand) brand = prodBrand.toLowerCase();
  var searchQ = null;
  try { var params = new URLSearchParams(window.location.search); searchQ = params.get('q') || null; } catch(e) {}
  var hour = new Date().getHours();
  var timeGreet = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';

  // Recently-viewed tracking (v2): stores objects with handle so the home strip
  // can verify availability against Shopify. Legacy 'bopf_viewed' (string array)
  // is left untouched and ignored.
  var viewedV2 = [];
  try { viewedV2 = JSON.parse(localStorage.getItem('bopf_viewed_v2') || '[]'); } catch(e) {}
  if (type === 'product' && prod) {
    var prodHandle = null;
    var hm = path.match(/\/products\/([^\/\?#]+)/);
    if (hm) prodHandle = hm[1];
    if (prodHandle) {
      // Dedupe by handle, move to front
      viewedV2 = viewedV2.filter(function(v){ return v && v.handle !== prodHandle; });
      viewedV2.unshift({
        handle: prodHandle,
        title:  prod,
        brand:  brand || (prod.split(' ')[0] || '').toLowerCase(),
        image:  prodImg || null,
        price:  ctx_parsePriceToAED(prodPrice),
        ts:     Date.now()
      });
      viewedV2 = viewedV2.slice(0, 5);
      try { localStorage.setItem('bopf_viewed_v2', JSON.stringify(viewedV2)); } catch(e) {}
    }
  }
  return { type:type, product:prod, prodPrice:prodPrice, prodBrand:prodBrand, prodImg:prodImg, brand:brand, searchQ:searchQ, timeGreet:timeGreet, viewed:viewedV2.map(function(v){return v.title;}) };
}

// Parse 'Dhs. 38,500' or 'Dhs 38500.00' into a number. Returns null when unparseable.
function ctx_parsePriceToAED(str) {
  if (!str) return null;
  var m = String(str).replace(/[^0-9.]/g, '');
  var n = parseFloat(m);
  return isNaN(n) ? null : n;
}

function fetchCart(callback) {
  var xhr = new _XHR();
  _xhrOpen.call(xhr, 'GET', '/cart.js', true);
  xhr.timeout = 5000;
  xhr.onload = function() {
    try {
      var cart = JSON.parse(xhr.responseText);
      var totalAED = (cart.total_price || 0) / 100;
      var items = (cart.items || []).map(function(item) {
        return { title: item.title, handle: item.handle || null, price: 'Dhs. ' + (item.price / 100).toLocaleString(), priceRaw: item.price / 100, qty: item.quantity, img: item.image };
      });
      callback(items, totalAED);
    } catch(e) { callback([], 0); }
  };
  xhr.onerror = xhr.ontimeout = function() { callback([], 0); };
  _xhrSend.call(xhr, null);
}

function isUAEVisitor() {
  try {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz === 'Asia/Dubai') return true;
    return -new Date().getTimezoneOffset() === 240;
  } catch(e) { return false; }
}

function isFirstTimeBuyer() {
  try {
    var mem = memLoad();
    if (window.bopfCustomerOrders && window.bopfCustomerOrders > 0) return false;
    return !mem.lastVisit || (mem.sessionCount || 0) < 2;
  } catch(e) { return true; }
}

// ── SHOPIFY SEARCH ────────────────────────────────────────────────────
function gqlRequest(gql, callback) {
  var xhr = new _XHR();
  _xhrOpen.call(xhr, 'POST', 'https://'+DOMAIN+'/api/2026-01/graphql.json', true);
  _xhrHeader.call(xhr, 'Content-Type', 'application/json');
  _xhrHeader.call(xhr, 'X-Shopify-Storefront-Access-Token', TOKEN);
  xhr.timeout = 8000;
  xhr.onload = function() {
    try {
      var d = JSON.parse(xhr.responseText);
      var items = (d&&d.data&&d.data.products&&d.data.products.edges||[]).map(function(e){return e.node;}).filter(function(p){return p.availableForSale!==false;});
      callback(items);
    } catch(e) { callback([]); }
  };
  xhr.onerror = function() { callback([]); };
  xhr.ontimeout = function() { callback([]); };
  _xhrSend.call(xhr, JSON.stringify({query:gql}));
}

function buildProductGQL(q, limit, sortKey, reverse) {
  limit = limit || 6; sortKey = sortKey || 'CREATED_AT'; reverse = (reverse === false) ? false : true;
  var f = 'title handle onlineStoreUrl availableForSale priceRange { minVariantPrice { amount currencyCode } } images(first:1){ edges { node { url } } } variants(first:1){ edges { node { sku } } }';
  return '{ products(first:'+limit+', query:"'+(q?q.replace(/"/g,'')+' ':'')+'available_for_sale:true", sortKey:'+sortKey+', reverse:'+reverse+') { edges { node { '+f+' } } } }';
}

function searchInventory(query, callback) {
  if (!query || query.length < 2) { callback([]); return; }
  var q = query.trim().replace(/"/g,'').slice(0, 100);
  if (q.indexOf('sku:') === 0) { gqlRequest(buildProductGQL('sku:' + q.slice(4).trim(), 4), callback); return; }
  if (q === '__new_arrivals__') { gqlRequest(buildProductGQL('', 8, 'CREATED_AT', true), callback); return; }
  // Use the bopf-price-drops collection directly instead of tag filtering.
  // Matches what's actually shown on the storefront collection page, and is
  // more reliable than tag filtering (which depends on consistent tagging).
  // Falls back to tag:pricedrops then tag:price-drops if collection returns 0.
  if (q === '__price_drops__') {
    var collGql = '{ collection(handle:"bopf-price-drops") { products(first:8, sortKey:COLLECTION_DEFAULT) { edges { node { title handle onlineStoreUrl availableForSale priceRange { minVariantPrice { amount currencyCode } } images(first:1){ edges { node { url } } } variants(first:1){ edges { node { sku } } } }} } } }';
    // Collection query returns data.collection.products.edges (not data.products.edges),
    // so gqlRequest's default parser won't find items. Run a raw XHR and parse here.
    var cxhr = new _XHR();
    _xhrOpen.call(cxhr, 'POST', 'https://'+DOMAIN+'/api/2026-01/graphql.json', true);
    _xhrHeader.call(cxhr, 'Content-Type', 'application/json');
    _xhrHeader.call(cxhr, 'X-Shopify-Storefront-Access-Token', TOKEN);
    cxhr.timeout = 8000;
    cxhr.onload = function() {
      var items = [];
      try {
        var d = JSON.parse(cxhr.responseText);
        items = (d&&d.data&&d.data.collection&&d.data.collection.products&&d.data.collection.products.edges||[])
          .map(function(e){return e.node;})
          .filter(function(p){return p.availableForSale!==false;});
      } catch(e) {}
      if (items.length) { callback(items); return; }
      // Fallback 1: tag:pricedrops
      gqlRequest(buildProductGQL('tag:pricedrops', 8, 'UPDATED_AT', true), function(r1) {
        if (r1 && r1.length) { callback(r1); return; }
        // Fallback 2: tag:price-drops (hyphenated)
        gqlRequest(buildProductGQL('tag:price-drops', 8, 'UPDATED_AT', true), callback);
      });
    };
    cxhr.onerror = function() { callback([]); };
    cxhr.ontimeout = function() { callback([]); };
    _xhrSend.call(cxhr, JSON.stringify({query:collGql}));
    return;
  }
  var preferredBrands = extractSearchQuery._occasionBrands || null;
  // Apply profile-derived filters (e.g. shoe size) before hitting Shopify.
  var refined = refineQueryWithProfile(q);
  function sortByPreferredBrands(items) {
    if (!preferredBrands || !preferredBrands.length) return items;
    return items.slice().sort(function(a, b) {
      var aT = (a.title||'').toLowerCase(), bT = (b.title||'').toLowerCase();
      var aS = preferredBrands.findIndex(function(br){return aT.indexOf(br)>-1;});
      var bS = preferredBrands.findIndex(function(br){return bT.indexOf(br)>-1;});
      return (aS<0?999:aS) - (bS<0?999:bS);
    });
  }
  gqlRequest(buildProductGQL(refined, 12), function(results) {
    if (results.length >= 2) { callback(sortByPreferredBrands(results)); return; }
    var combined = results.slice(); var seen = {}; results.forEach(function(p){ seen[p.handle]=true; });
    var pending = 2;
    function merge(items) {
      items.forEach(function(p){ if(!seen[p.handle]){seen[p.handle]=true;combined.push(p);} });
      if (--pending === 0) callback(sortByPreferredBrands(combined).slice(0,8));
    }
    // Fallbacks use the un-refined query so we don't double-filter into zero.
    gqlRequest(buildProductGQL('product_type:' + q, 6), merge);
    gqlRequest(buildProductGQL('tag:' + q, 6), merge);
  });
}

function extractSearchQuery(text) {
  var t = text.toLowerCase();
  var skuExplicit = text.match(/sku[:\s]+([a-z0-9\-_]+)/i);
  if (skuExplicit) return 'sku:' + skuExplicit[1].trim();
  var bareSku = text.trim().match(/^([a-z0-9][a-z0-9\-_]{2,20})$/i);
  if (bareSku && /[0-9\-_]/.test(bareSku[1])) return 'sku:' + bareSku[1];
  if (/new arrival|just in|just arrived|latest|newest|recently added|what.s new|what is new|new in/i.test(t)) return '__new_arrivals__';
  if (/price drop|on sale|reduced|discount|markdown|cheaper|deal|bargain|sale price/i.test(t)) return '__price_drops__';
  t = t.replace(/jewellery/g,'jewelry').replace(/colour/g,'color').replace(/grey/g,'gray').replace(/handbag/g,'bag').replace(/purse/g,'bag').replace(/pocketbook/g,'bag');
  var brandMap = [
    {q:'bottega veneta',rx:/bott?eg|veneta|venetta|b\.?v/},{q:'chanel',rx:/chan[ae]l|coco\s*chanel/},
    {q:'hermes',rx:/herm[e\u00e8]s|herm[ea]|birkin|kelly|picotin|constance|evelyne/},
    {q:'louis vuitton',rx:/louis\s*v[iue]+t+on|l\.?\s*v\.?|lou[iy]s|vuitton|lv/},
    {q:'dior',rx:/dio+r/},{q:'gucci',rx:/gucc?i/},{q:'cartier',rx:/cartie?r/},
    {q:'balenciaga',rx:/balen[sc]i?ag|balen/},{q:'fendi',rx:/fend[iy]/},{q:'prada',rx:/prad[ae]/},
    {q:'burberry',rx:/burberr?y|burbs/},{q:'celine',rx:/c[e\u00e9]line/},{q:'valentino',rx:/valentin[oa]/},
    {q:'givenchy',rx:/givenchy|given/},{q:'saint laurent',rx:/saint\s*laur[ae]nt|ysl|y\.s\.l|yves/},
    {q:'versace',rx:/versac[eay]/},{q:'bvlgari',rx:/bvlgari|bulgari|bvlg/},{q:'tiffany',rx:/tiffan/},
    {q:'van cleef',rx:/van\s*cleef|arpels/},{q:'loewe',rx:/loew[e\u00e9]/},{q:'miu miu',rx:/miu\s*miu/},
    {q:'alexander mcqueen',rx:/mcqueen|alexander\s*mc/},{q:'chloe',rx:/chlo[e\u00e9]/},
    {q:'goyard',rx:/goyar/},{q:'moynat',rx:/moyna/}
  ];
  var matchedBrand = null;
  for (var i = 0; i < brandMap.length; i++) { if (brandMap[i].rx.test(t)) { matchedBrand = brandMap[i].q; break; } }
  var categoryMap = {'bag':'bag','bags':'bag','jewelry':'jewelry','jewellery':'jewelry','necklace':'necklace','bracelet':'bracelet','earring':'earring','ring':'ring','watch':'watch','watches':'watch','belt':'belt','scarf':'scarf','wallet':'wallet','clutch':'clutch','tote':'tote','backpack':'backpack','shoes':'shoes','boots':'boots','heels':'heels','sneakers':'sneakers','sandals':'sandals','sunglasses':'sunglasses','loafer':'loafer','pump':'pumps','slingback':'slingback','mule':'mule'};
  var matchedCategory = null;
  var catKeys = Object.keys(categoryMap);
  for (var j = 0; j < catKeys.length; j++) { if (t.indexOf(catKeys[j]) > -1) { matchedCategory = categoryMap[catKeys[j]]; break; } }
  var parts = []; if (matchedBrand) parts.push(matchedBrand); if (matchedCategory) parts.push(matchedCategory);
  if (parts.length) return parts.join(' ');
  var occasionMap = [
    {rx:/party\s*dress|night\s*out|going\s*out|club|disco/,q:'dress',brands:['jacquemus','attico','alexandre vauthier','retrofete','nensi dojaka','versace','dior']},
    {rx:/beach\s*wedding|garden\s*wedding|wedding|bridal|bride/,q:'dress gown',brands:['dior','valentino','chanel','givenchy','elie saab','chloe','jacquemus']},
    {rx:/black\s*tie|gala|red\s*carpet|formal\s*event/,q:'evening gown formal',brands:['dior','valentino','givenchy','versace','saint laurent','chanel']},
    {rx:/brunch|lunch|casual\s*chic|weekend|daytime/,q:'dress top',brands:['jacquemus','sandro','maje','ganni','chloe','isabel marant','zimmermann']},
    {rx:/chic|classic\s*style|elegant|sophisticated|timeless/,q:'dress blazer',brands:['chanel','hermes','saint laurent','celine','dior','bottega veneta']},
    {rx:/summer|resort|beach(?!\s*wedding)|holiday\s*outfit|vacation/,q:'summer dress',brands:['jacquemus','zimmermann','missoni','valentino','etro','pucci']},
    {rx:/winter\s*outfit|cold\s*weather|cosy|cozy/,q:'coat jacket',brands:['max mara','burberry','toteme','bottega veneta','chanel','hermes']},
    {rx:/office|work\s*outfit|professional|corporate|meeting/,q:'blazer suit dress',brands:['chanel','saint laurent','celine','boss','theory','roland mouret']},
    {rx:/date\s*night|date\s*outfit|romantic/,q:'dress',brands:['jacquemus','attico','saint laurent','dior','versace']},
    {rx:/gift\s*(idea|for|her|him)|present/,q:'luxury',brands:['chanel','hermes','dior','gucci','cartier','louis vuitton']},
    {rx:/travel\s*outfit|airport|long\s*haul|flight/,q:'comfortable luxury',brands:['hermes','loro piana','bottega veneta','max mara']}
  ];
  var matchedOccasion = null;
  for (var oi = 0; oi < occasionMap.length; oi++) { if (occasionMap[oi].rx.test(t)) { matchedOccasion = occasionMap[oi]; break; } }
  if (matchedOccasion) { extractSearchQuery._occasionBrands = matchedOccasion.brands; return matchedOccasion.q; }
  extractSearchQuery._occasionBrands = null;
  var cleaned = t.replace(/\b(please|could you|can you|do you have|i am looking for|im looking for|i want|i need|i would love|id love|show me|find me|looking for|something like|do you stock|have you got|got any|any|tell me about|what about|show me|got|have)\b/g,' ').replace(/\s+/g,' ').trim();
  return cleaned.length > 2 ? cleaned : text;
}

// ── CLAUDE API CALL ───────────────────────────────────────────────────
function callClaude(messages, metadata, callback) {
  var xhr = new _XHR();
  _xhrOpen.call(xhr, 'POST', PROXY_URL, true);
  _xhrHeader.call(xhr, 'Content-Type', 'application/json');
  xhr.timeout = 55000;
  xhr.onload = function() {
    try {
      if (xhr.status < 200 || xhr.status >= 300) throw new Error('Status '+xhr.status);
      var d = JSON.parse(xhr.responseText);
      if (!d || !d.reply) throw new Error('Empty reply');
      // Pass full response so caller can read profileSaves and other fields.
      callback(null, d.reply, d);
    } catch(e) { callback(e, null, null); }
  };
  xhr.onerror = function() { callback(new Error('Network error'), null, null); };
  xhr.ontimeout = function() { callback(new Error('Timeout'), null, null); };
  _xhrSend.call(xhr, JSON.stringify({
    messages:        messages,
    sessionId:       SESSION_ID,
    pageUrl:         window.location.href,
    visitorRegion:   isUAEVisitor() ? 'UAE' : 'International',
    searchQuery:     metadata.searchQuery || '',
    productTitles:   metadata.productTitles || '',
    zeroResults:     metadata.zeroResults || false,
    whatsappShown:   metadata.whatsappShown || false,
    messageNumber:   messageCount,
    cartValue:       cartValueAtStart,
    archetypeContext: metadata.archetypeContext || null
  }));
}

// ── DOM HELPERS ───────────────────────────────────────────────────────
function append(role, text) {
  var msgs=document.getElementById('bopf-msgs');
  var d=document.createElement('div'); d.className='b-msg '+role;
  var av=role==='ai'?'<div class="b-av ai"><img src="'+LOGO+'" alt="Z"></div>':'<div class="b-av u">You</div>';
  var bbl=document.createElement('div'); bbl.className='b-bbl';

  // Extract any Google Maps URLs from AI messages and render them as a button
  // instead of inline text. Long raw URLs break out of the bubble on desktop.
  // Match any maps.google.com, google.com/maps, or goo.gl/maps URL.
  var mapsUrl = null;
  var processedText = text;
  if (role === 'ai') {
    var mapsMatch = text.match(/https?:\/\/(?:www\.)?(?:maps\.google\.com|google\.com\/maps|goo\.gl\/maps)[^\s<>()"']+/i);
    if (mapsMatch) {
      mapsUrl = mapsMatch[0];
      // Strip the URL from the text so it doesn't render inline anymore.
      processedText = text.replace(mapsUrl, '').replace(/\s{2,}/g,' ').replace(/[ ,:;.]+$/, '').trim();
    }
  }

  bbl.innerHTML=processedText.replace(/\n/g,'<br>');

  // If we extracted a Maps URL, append a clean button below the text.
  if (mapsUrl) {
    var mapsBtn = document.createElement('a');
    mapsBtn.href = mapsUrl;
    mapsBtn.target = '_blank';
    mapsBtn.rel = 'noopener';
    mapsBtn.className = 'b-maps';
    // SVG pin icon + "Open in Google Maps" label, styled consistently with the WhatsApp button.
    mapsBtn.innerHTML = '<svg viewBox="0 0 24 24" style="width:16px;height:16px;fill:currentColor;flex-shrink:0"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg><span>Open in Google Maps</span>';
    mapsBtn.addEventListener('click', function(){ logEvent('maps_click', 'location_pin'); });
    bbl.appendChild(mapsBtn);
  }

  d.innerHTML=av; d.appendChild(bbl);
  msgs.appendChild(d); msgs.scrollTop=msgs.scrollHeight;
  return d;
}

function typing(show) {
  if(show){
    var msgs=document.getElementById('bopf-msgs');
    var d=document.createElement('div'); d.id='bopf-typ'; d.className='b-msg ai';
    d.innerHTML='<div class="b-av ai"><img src="'+LOGO+'" alt="Z"></div><div class="b-typing"><span></span><span></span><span></span></div>';
    msgs.appendChild(d); msgs.scrollTop=msgs.scrollHeight;
  } else { var el=document.getElementById('bopf-typ'); if(el) el.parentNode.removeChild(el); }
}

function renderCards(products, msgEl) {
  var bbl = msgEl.querySelector('.b-bbl');
  products.slice(0,4).forEach(function(p) {
    var pr = p.priceRange && p.priceRange.minVariantPrice;
    var rawUrl = p.onlineStoreUrl || ('https://businessofprelovedfashion.com/products/' + p.handle);
    var url = appendUTM(rawUrl);
    var img = p.images && p.images.edges && p.images.edges[0] && p.images.edges[0].node && p.images.edges[0].node.url;
    var sku = p.variants && p.variants.edges && p.variants.edges[0] && p.variants.edges[0].node && p.variants.edges[0].node.sku;
    var cur = pr && parseFloat(pr.amount);
    var a = document.createElement('a');
    a.className = 'b-card'; a.href = url; a.target = '_blank'; a.rel = 'noopener';
    a.innerHTML = (img ? '<img src="'+img+'" alt="'+p.title+'">' : '')
      + '<div class="b-ci">'
      + '<div class="b-cb">'+p.title.split(' ')[0]+(sku?' &middot; <span style="opacity:.55;font-size:7px">'+sku+'</span>':'')+'</div>'
      + '<div class="b-ct">'+p.title+'</div>'
      + '<div class="b-cf">'
      + (cur ? '<div class="b-cp">Dhs. '+cur.toLocaleString()+'</div>' : '')
      + '<span class="b-cl">View &rarr;</span>'
      + '</div></div>';
    a.addEventListener('click', function() { logEvent('card_click', p.title + (cur ? ' | Dhs. ' + cur.toLocaleString() : '')); });
    bbl.appendChild(a);
  });
}

function buildTranscript() {
  var msgs = document.getElementById('bopf-msgs').querySelectorAll('.b-msg');
  var lines = ['Hi BOPF! I was just chatting with Zara your concierge. Here is our conversation:\n'];
  msgs.forEach(function(m) {
    var bbl = m.querySelector('.b-bbl');
    if (!bbl) return;
    var role = m.classList.contains('user') ? 'Me' : 'Zara';
    var txt = bbl.innerText.replace(/View piece.*$/gm,'').trim();
    if (txt) lines.push(role + ': ' + txt);
  });
  lines.push('\nCan you help me continue from here?');
  return lines.join('\n');
}

function showWishlistAndWA(item, msgEl) {
  var bbl = msgEl.querySelector('.b-bbl');
  var transcript = buildTranscript();
  var waMsg = encodeURIComponent(transcript);
  if (waMsg.length > 3000) waMsg = encodeURIComponent('Hi BOPF, I was chatting with Zara your concierge about: ' + item + '. Can you help me?');
  var waUrl = 'https://wa.me/' + WA + '?text=' + waMsg;
  var link = document.createElement('a');
  link.href = waUrl; link.target = '_blank'; link.rel = 'noopener'; link.className = 'b-wa'; link.style.marginTop = '10px';
  link.innerHTML = '<svg viewBox="0 0 24 24" style="width:15px;height:15px;fill:#fff;flex-shrink:0"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.121 1.533 5.849L0 24l6.335-1.509A11.954 11.954 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.806 9.806 0 0 1-5.032-1.387l-.36-.214-3.732.888.944-3.643-.235-.374A9.778 9.778 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z"/></svg>'
    + ' Chat with our team on WhatsApp';
  link.addEventListener('click', function() { logEvent('whatsapp_click', item || 'general'); });
  bbl.appendChild(link);
  document.getElementById('bopf-msgs').scrollTop = 9999;
}

function renderSugs(list) {
  var el=document.getElementById('bopf-sugs');
  el.innerHTML=''; el.style.display=list.length?'flex':'none';
  list.forEach(function(s){
    var b=document.createElement('button'); b.className='b-sug'; b.textContent=s;
    b.addEventListener('click',function(){ sendMessage(s); }); el.appendChild(b);
  });
}

// ── MAIN SEND LOGIC ───────────────────────────────────────────────────
function sendMessage(text, imageData) {
  if(isLoading) return;
  text=(text||'').trim();
  if(!text && !imageData) return;
  messageCount++;
  var inp=document.getElementById('bopf-inp');
  inp.value=''; inp.style.height='auto';
  document.getElementById('bopf-sugs').style.display='none';
  if(imageData){
    var msgs=document.getElementById('bopf-msgs');
    var d=document.createElement('div'); d.className='b-msg user';
    d.innerHTML='<div class="b-av u">You</div><div class="b-bbl"><img src="'+imageData+'" style="max-width:140px;max-height:120px;border-radius:3px;display:block;margin-bottom:4px;border:1px solid rgba(255,255,255,.2)"><span>'+(text||'Can you find something like this?')+'</span></div>';
    msgs.appendChild(d); msgs.scrollTop=msgs.scrollHeight;
  } else { append('user', text); }
  isLoading=true;
  document.getElementById('bopf-send').disabled=true;
  typing(true);
  var searchQ = extractSearchQuery(text);
  function runSearch(q, fallback, cb) {
    searchInventory(q, function(results) { if (results.length || !fallback) { cb(results); return; } searchInventory(fallback, cb); });
  }
  var fallbackQ = text.length > 3 ? text.replace(/[^a-z0-9 ]/gi,'').split(' ').slice(0,2).join(' ') : null;
  runSearch(searchQ, fallbackQ, function(products) {
    var ctx = getPageContext();
    var pageCtx = '';
    if (ctx.type === 'product' && ctx.product) {
      pageCtx = ' [Customer is viewing: ' + ctx.product + (ctx.prodPrice ? ' priced at ' + ctx.prodPrice : '') + (ctx.prodBrand ? ' by ' + ctx.prodBrand : '') + ']';
    } else if (ctx.type === 'cart') {
      pageCtx = ' [Customer is on the cart page]';
    } else if (ctx.brand) {
      pageCtx = ' [Customer is browsing: ' + ctx.brand + ' collection]';
    } else if (ctx.type === 'search' && ctx.searchQ) {
      pageCtx = ' [Customer searched for: ' + ctx.searchQ + ']';
    }
    pageCtx += isUAEVisitor() ? ' [Visitor is in UAE]' : ' [Visitor is outside UAE]';
    // Append profile tag so Zara knows shoe size, designers, budget, etc.
    pageCtx += profileToContextTag();
    var productTitlesList = (products || []).map(function(p) { return p.title; }).join('|');
    var zeroResults = !products || products.length === 0;
    var searchCtx = '';
    if(products && products.length) {
      searchCtx = '\n\nSEARCH RESULTS (in stock, newest first):\n' + products.map(function(p){
        var pr = p.priceRange && p.priceRange.minVariantPrice;
        var rawUrl = p.onlineStoreUrl || ('https://businessofprelovedfashion.com/products/' + p.handle);
        return '- ' + p.title + (pr ? ' | Dhs. ' + parseFloat(pr.amount).toLocaleString() : '') + ' | ' + appendUTM(rawUrl);
      }).join('\n');
    } else {
      searchCtx = '\n\nSEARCH RESULTS: No matching items in stock right now.';
    }
    var userContent;
    if(imageData){
      var base64=imageData.split(',')[1];
      var mime=(imageData.match(/data:(image\/\w+);/)||[])[1]||'image/jpeg';
      userContent=[{type:'image',source:{type:'base64',media_type:mime,data:base64}},{type:'text',text:(text||'What is this and do you have anything similar?')+searchCtx+pageCtx}];
    } else {
      userContent = text + searchCtx + pageCtx;
    }
    history.push({role:'user', content:userContent});

    var archetypeContext = null;
    if (!archetypeContextSent) {
      var archetype = getBopfArchetype();
      if (archetype) {
        archetypeContext = buildArchetypeContext(archetype);
        archetypeContextSent = true;
      }
    }

    callClaude(history, {
      searchQuery:     searchQ,
      productTitles:   productTitlesList,
      zeroResults:     zeroResults,
      whatsappShown:   false,
      archetypeContext: archetypeContext
    }, function(err, reply, fullResponse) {
      typing(false); isLoading=false;
      document.getElementById('bopf-send').disabled=false;
      if(err || !reply) {
        var waMsg=encodeURIComponent('Hi! I was just chatting with your concierge and wanted to continue. I said: "'+text+'"');
        var msgEl=append('ai','Just a moment, let me connect you with our team directly who can help right now.');
        var bbl=msgEl.querySelector('.b-bbl');
        var link=document.createElement('a'); link.href='https://wa.me/'+WA+'?text='+waMsg;
        link.target='_blank'; link.rel='noopener'; link.className='b-wa'; link.style.marginTop='10px';
        link.textContent='Continue on WhatsApp \u2192';
        link.addEventListener('click', function() { logEvent('whatsapp_click', 'error_fallback'); });
        bbl.appendChild(link); history.pop(); inp.focus(); return;
      }
      // Apply any profile saves signalled by the server (silent, no UI).
      if (fullResponse && fullResponse.profileSaves && fullResponse.profileSaves.length) {
        var patch = {};
        fullResponse.profileSaves.forEach(function(s) {
          if (!s || !s.field) return;
          if (s.field === 'favourite_designers' || s.field === 'avoid_designers') {
            patch[s.field] = String(s.value || '').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
          } else {
            patch[s.field] = s.value;
          }
        });
        profileSave(patch);
        logEvent('profile_save', JSON.stringify(patch));
      }
      history.push({role:'assistant', content:reply});
      var msgEl=append('ai', reply);
      if(products && products.length) renderCards(products, msgEl);
      var cantHelp = /don.t have|not in stock|nothing.*match|out of stock|unable to|can.t help|cannot help|not sure|reach.*team|whatsapp|contact us/i.test(reply);
      if(!products || !products.length || cantHelp) showWishlistAndWA(searchQ, msgEl);
      var mem=memLoad(), brands=mem.brands||[];
      var brandNames=['hermes','chanel','dior','gucci','cartier','balenciaga','bottega','fendi'];
      brandNames.forEach(function(b){ if(text.toLowerCase().indexOf(b)>-1&&brands.indexOf(b)<0) brands.push(b); });
      memSave({brands:brands, sessionCount:(mem.sessionCount||0)+1});
      inp.focus();
    });
  });
}

// ── OPEN / CLOSE ──────────────────────────────────────────────────────
function bopfOpen() {
  isOpen=true;
  var pn = document.getElementById('bopf-pn');
  if (window.innerWidth <= 540) { pn.style.height = ''; pn.style.maxHeight = ''; }
  pn.classList.add('open');
  document.getElementById('bopf-bb').classList.add('open');
  document.getElementById('bopf-bi').innerHTML = LAUNCHER_CLOSE;
  if(window.innerWidth<=540){
    document.body.style.overflow='hidden';
    document.getElementById('bopf-bd').classList.add('open');
    if (!document.getElementById('bopf-hide-style')) {
      var s = document.createElement('style');
      s.id = 'bopf-hide-style';
      s.textContent = 'body.bopf-open #shopify-chat,body.bopf-open [id*="shopify-chat"],body.bopf-open [class*="shopify-chat"],body.bopf-open [id*="chat-button"],body.bopf-open iframe[src*="chat"],body.bopf-open iframe[src*="inbox"],body.bopf-open iframe[src*="messenger"],body.bopf-open [id*="tidio"],body.bopf-open [id*="crisp"],body.bopf-open [id*="gorgias"],body.bopf-open [id*="intercom"],body.bopf-open [id*="zendesk"],body.bopf-open [class*="chat-widget"],body.bopf-open [class*="live-chat"]{display:none!important;visibility:hidden!important;opacity:0!important}';
      document.head.appendChild(s);
    }
    document.body.classList.add('bopf-open');
  }
  if (!didGreet) { fetchCart(function(items, totalAED) { cartValueAtStart = totalAED; }); bopfGreet(); }
  setTimeout(function(){ document.getElementById('bopf-inp').focus(); },350);
}

function bopfClose() {
  isOpen=false;
  document.getElementById('bopf-pn').classList.remove('open');
  document.getElementById('bopf-bb').classList.remove('open');
  document.getElementById('bopf-bi').innerHTML = BELL_SVG;
  document.body.style.overflow='';
  document.getElementById('bopf-bd').classList.remove('open');
  document.body.classList.remove('bopf-open');
}

// ── GREET ─────────────────────────────────────────────────────────────
function bopfGreet() {
  didGreet=true;
  var mem=memLoad(), ctx=getPageContext(), brands=mem.brands||[];
  var msg='';
  var custName = null;
  try { if (window.bopfCustomerName && typeof window.bopfCustomerName === 'string') custName = window.bopfCustomerName.trim().split(' ')[0]; } catch(e) {}
  var hi = custName ? ctx.timeGreet + ', ' + custName + '!' : ctx.timeGreet + '!';
  var welcome = custName ? 'Welcome back, ' + custName + '!' : 'Welcome back!';

  var archetype = getBopfArchetype();
  if (archetype && ctx.type !== 'cart') {
    var nameGreet = custName ? ctx.timeGreet + ', ' + custName : 'Welcome back';
    var brandLine = (archetype.brand && archetype.brand !== 'any') ? ' with a love for ' + archetype.brand : '';
    var collectorLine = archetype.collector === 'first'     ? ' Ready to find your first icon?'
                      : archetype.collector === 'gift'      ? ' Looking for the perfect gift?'
                      : archetype.collector === 'replacing' ? ' Ready for your next chapter?'
                      : '';
    msg = nameGreet + ', ' + archetype.name + brandLine + '.' + collectorLine + " Want to see what's new in your edit, or are you after something specific?";
    append('ai', msg);
    var searchTerm = (archetype.brand && archetype.brand !== 'any') ? archetype.brand : '__new_arrivals__';
    searchInventory(searchTerm, function(comps) {
      if (comps.length) {
        var cardsMsg = append('ai', archetype.brand && archetype.brand !== 'any' ? 'Here is what we have in ' + archetype.brand + ' right now:' : 'Here is what just landed:');
        renderCards(comps.slice(0,3), cardsMsg);
      }
      renderSugs((omnisendFresh ? ['What\u2019s new this week'] : []).concat(
        archetype.brand && archetype.brand !== 'any'
        ? ['More ' + archetype.brand, 'New arrivals', 'Investment pieces', 'Gift ideas']
        : ['New arrivals', 'Chanel bags', 'Investment pieces', 'Gift under AED 5,000']
      ));
      memSave({sessionCount:(mem.sessionCount||0)+1, lastVisit:new Date().toISOString()});
    });
    return;
  }

  function finishGreet(extraCards) {
    append('ai', msg);
    if (extraCards && extraCards.length) { var cardsMsg = append('ai', 'A few pieces that might also catch your eye:'); renderCards(extraCards, cardsMsg); }
    renderSugs((omnisendFresh ? ['What\u2019s new this week'] : []).concat(
      ['Chanel bags','Wedding outfit ideas','Investment pieces','Gift under AED 5,000']
    ));
    memSave({sessionCount:(mem.sessionCount||0)+1, lastVisit:new Date().toISOString()});
  }

  if (ctx.type === 'cart') {
    fetchCart(function(items, totalAED) {
      cartValueAtStart = totalAED;
      if (items.length) {
        var names = items.slice(0,2).map(function(i){ return i.title.split(' ').slice(0,3).join(' '); }).join(' and ');
        var uae = isUAEVisitor();
        msg = hi + ' I can see you have ' + names + ' in your cart, great choice.';
        if (uae) { msg += ' Did you know you can split this into easy payments with Tabby or Tamara at checkout? No interest, no hassle.'; }
        else if (!uae && isFirstTimeBuyer() && totalAED >= 1500) { msg += ' As a first-time international customer, use code BOPF150 at checkout for Dhs. 150 off, our welcome gift to you.'; }
        else { msg += ' Any questions before you checkout?'; }
        append('ai', msg);
        if (!uae && isFirstTimeBuyer() && totalAED >= 1500) {
          var discountEl = append('ai', ''); var dBbl = discountEl.querySelector('.b-bbl');
          var dCard = document.createElement('div');
          dCard.style.cssText = 'background:var(--cr2);border:1px dashed var(--a);border-radius:8px;padding:10px 14px;margin-top:4px;display:flex;align-items:center;justify-content:space-between;gap:10px';
          var dInfo = document.createElement('div');
          dInfo.innerHTML = '<div style="font-family:var(--fn);font-size:8px;letter-spacing:.14em;text-transform:uppercase;color:var(--a);margin-bottom:3px">Welcome discount</div><div style="font-family:var(--fn);font-size:18px;font-weight:500;color:var(--tx);letter-spacing:.08em">BOPF150</div><div style="font-family:var(--fn);font-size:10px;color:var(--mu);margin-top:2px">Dhs. 150 off your order</div>';
          var dBtn = document.createElement('button');
          dBtn.textContent = 'Copy code'; dBtn.style.cssText = 'background:var(--a);color:#fff;border:none;border-radius:6px;padding:8px 14px;font-family:var(--fn);font-size:10px;font-weight:500;cursor:pointer;white-space:nowrap;flex-shrink:0';
          dBtn.addEventListener('click', function() { try { navigator.clipboard.writeText('BOPF150'); } catch(e) {} dBtn.textContent = 'Copied!'; dBtn.style.background = 'var(--gn)'; logEvent('discount_copy', 'BOPF150'); });
          dCard.appendChild(dInfo); dCard.appendChild(dBtn); dBbl.appendChild(dCard);
        }
        if (uae) {
          var bnplEl = append('ai', ''); var bnplBbl = bnplEl.querySelector('.b-bbl');
          bnplBbl.innerHTML = '<div style="background:var(--cr2);border:0.5px solid var(--bd);border-radius:8px;padding:10px 14px;margin-top:4px"><div style="font-family:var(--fn);font-size:8px;letter-spacing:.14em;text-transform:uppercase;color:var(--a);margin-bottom:8px">Pay in instalments</div><div style="display:flex;gap:10px;align-items:center"><div style="flex:1;background:var(--w);border:0.5px solid var(--bd);border-radius:6px;padding:8px 12px;text-align:center"><div style="font-family:var(--fn);font-size:13px;font-weight:500;color:var(--tx)">Tabby</div><div style="font-family:var(--fn);font-size:9px;color:var(--mu)">4 payments, 0% interest</div></div><div style="flex:1;background:var(--w);border:0.5px solid var(--bd);border-radius:6px;padding:8px 12px;text-align:center"><div style="font-family:var(--fn);font-size:13px;font-weight:500;color:var(--tx)">Tamara</div><div style="font-family:var(--fn);font-size:9px;color:var(--mu)">Split into 3, interest free</div></div></div><div style="font-family:var(--fn);font-size:9px;color:var(--mu);margin-top:7px">Both available at checkout, no sign-up needed.</div></div>';
        }
        var cartBrand = items[0].title.split(' ')[0];
        searchInventory(cartBrand, function(comps) { var cartTitles = items.map(function(i){ return i.title; }); finishGreet(comps.filter(function(p){ return cartTitles.indexOf(p.title)<0; }).slice(0,3)); });
      } else { msg = hi + ' You are so close. Any last questions before you complete your order? I am right here.'; finishGreet([]); }
    });
    return;
  }

  if (ctx.type === 'product' && ctx.product) {
    var priceStr = ctx.prodPrice ? ' at ' + ctx.prodPrice : '';
    msg = hi + ' I see you are looking at the ' + ctx.product + priceStr + '. Want to know more about it, find similar pieces, or see what pairs well with it?';
    var compQ = ctx.prodBrand || ctx.product.split(' ')[0];
    searchInventory(compQ, function(comps) { finishGreet(comps.filter(function(p){ return p.title !== ctx.product; }).slice(0,3)); });
    return;
  }

  if (brands.length && (mem.sessionCount||0) > 1) {
    var top = brands[0].replace(/^\w/, function(ch){ return ch.toUpperCase(); });
    msg = welcome + ' Last time you were browsing ' + top + ' pieces, shall I show you what has come in since?';
    searchInventory(brands[0], function(comps) { finishGreet(comps.slice(0,3)); });
    return;
  }

  if (ctx.brand) {
    var br = ctx.brand.replace(/^\w/, function(ch){ return ch.toUpperCase(); });
    msg = hi + ' I see you are browsing ' + br + ', great taste. Are you looking for something specific, or shall I show you our best pieces?';
    searchInventory(ctx.brand, function(comps) { finishGreet(comps.slice(0,3)); });
    return;
  }

  if (ctx.type === 'search' && ctx.searchQ) {
    msg = hi + ' I see you searched for "' + ctx.searchQ + '", let me help you find the right piece.';
    searchInventory(ctx.searchQ, function(comps) { finishGreet(comps.slice(0,3)); });
    return;
  }

  var greets = [
    hi + ' I am Zara, your BOPF personal concierge. I can help you find a specific piece, build an outfit for an occasion, or just talk through what works for you.',
    hi + ' I am Zara from BOPF, your luxury fashion friend who knows the entire collection. What can I help with today?',
    hi + ' I am Zara from BOPF. A specific piece, a full outfit, honest advice on what is worth buying, I am here for all of it.'
  ];
  msg = greets[Math.floor(Math.random() * greets.length)];
  finishGreet([]);
}

// ── IMAGE UPLOAD ──────────────────────────────────────────────────────
function handleImageUpload(file) {
  if(!file) return;
  if(file.size>8*1024*1024){ alert('Please use an image under 8MB.'); return; }
  var reader=new FileReader();
  reader.onload=function(e){ sendMessage('', e.target.result); };
  reader.readAsDataURL(file);
}

// ── SWIPE TO DISMISS ──────────────────────────────────────────────────
(function(){
  var handle=document.getElementById('bopf-handle'), panel=document.getElementById('bopf-pn');
  var sy=0,cy=0,dr=false;
  handle.addEventListener('touchstart',function(e){sy=e.touches[0].clientY;dr=true;panel.style.transition='none';},{passive:true});
  handle.addEventListener('touchmove',function(e){if(!dr)return;cy=e.touches[0].clientY;panel.style.transform='translateY('+Math.max(0,cy-sy)+'px)';},{passive:true});
  handle.addEventListener('touchend',function(){if(!dr)return;dr=false;panel.style.transition='';if((cy-sy)>100)bopfClose();else panel.style.transform='';sy=0;cy=0;});
})();

// ── VISUAL VIEWPORT ───────────────────────────────────────────────────
function onVVR(){ if(!isOpen||!window.visualViewport) return; if(window.innerHeight-window.visualViewport.height-window.visualViewport.offsetTop>50) document.getElementById('bopf-msgs').scrollTop=9999; }
if(window.visualViewport) window.visualViewport.addEventListener('resize',onVVR);

// ── QUIZ INTEGRATION ──────────────────────────────────────────────────
window.addEventListener('bopf:open', function() { if (!isOpen) bopfOpen(); });

// ── IDLE NUDGE SYSTEM ─────────────────────────────────────────────────
(function() {
  var nudgeEl = document.getElementById('bopf-nudge');
  var nudgeText = document.getElementById('bopf-nudge-text');
  var nudgeCta = document.getElementById('bopf-nudge-cta');
  var dismissBtn = nudgeEl.querySelector('.b-ndismiss');
  var bubble = document.getElementById('bopf-bb');
  var nudgeDismissed = 0;
  var nudgeTimers = [];

  function clearNudgeTimers() { nudgeTimers.forEach(function(t){ clearTimeout(t); }); nudgeTimers = []; }
  function hideNudge() { nudgeEl.classList.remove('show'); }
  function showNudge(msg, cta) { if (isOpen || didGreet) { hideNudge(); return; } nudgeText.textContent = msg; if (cta) nudgeCta.textContent = cta; nudgeEl.classList.add('show'); }
  function bounceBubble() { if (isOpen) return; bubble.classList.remove('bopf-bounce'); void bubble.offsetWidth; bubble.classList.add('bopf-bounce'); setTimeout(function(){ bubble.classList.remove('bopf-bounce'); }, 600); }

  dismissBtn.addEventListener('click', function(e) {
    e.stopPropagation(); hideNudge(); nudgeDismissed++;
    if (nudgeDismissed === 1) {
      nudgeTimers.push(setTimeout(function() {
        showNudge(['Still here if you need anything.','I can help you find the perfect piece.','Want me to check what just came in?'][Math.floor(Math.random()*3)], 'Ask Zara');
      }, 60000));
    }
  });
  nudgeCta.addEventListener('click', function() { hideNudge(); clearNudgeTimers(); bopfOpen(); });
  nudgeEl.addEventListener('click', function(e) { if (e.target === dismissBtn) return; hideNudge(); clearNudgeTimers(); bopfOpen(); });

  var ctx = getPageContext();
  var stage1Delay, stage2Delay, nudgeMsg, nudgeCTAText;

  var nudgeArchetype = getBopfArchetype();
  if (nudgeArchetype && ctx.type !== 'product' && ctx.type !== 'cart') {
    stage1Delay = 20000; stage2Delay = 40000;
    var brandHint = (nudgeArchetype.brand && nudgeArchetype.brand !== 'any') ? nudgeArchetype.brand + ' ' : '';
    nudgeMsg = 'I have new ' + brandHint + 'pieces that match your style. Want to see?';
    nudgeCTAText = 'Show me';
  } else if (ctx.type === 'product' && ctx.product) {
    stage1Delay = 15000; stage2Delay = 30000;
    var shortName = ctx.product.split(' ').slice(0, 3).join(' ');
    nudgeMsg = ['Want to know more about the ' + shortName + '?','I can tell you how the ' + shortName + ' holds its value.','Curious about this piece? I can help.'][Math.floor(Math.random()*3)];
    nudgeCTAText = 'Ask Zara';
  } else if (ctx.type === 'cart') {
    stage1Delay = 12000; stage2Delay = 25000;
    nudgeMsg = 'Any last questions before you checkout? I can help with sizing, shipping, or anything else.';
    nudgeCTAText = 'Chat with Zara';
  } else if (ctx.type === 'collection' || ctx.brand) {
    stage1Delay = 20000; stage2Delay = 45000;
    var br = (ctx.brand || 'this collection').replace(/^\w/, function(ch){ return ch.toUpperCase(); });
    nudgeMsg = 'Looking for something specific in ' + br + '? I can help narrow it down.';
    nudgeCTAText = 'Let Zara help';
  } else if (ctx.type === 'search') {
    stage1Delay = 10000; stage2Delay = 20000;
    nudgeMsg = 'Not finding what you need? Tell me what you are looking for.';
    nudgeCTAText = 'Ask Zara';
  } else {
    stage1Delay = 25000; stage2Delay = 50000;
    nudgeMsg = ['Looking for something special? I know the whole collection.','Need help finding the perfect piece? I am here.','Curious about a brand or looking for a gift? Let me help.'][Math.floor(Math.random()*3)];
    nudgeCTAText = 'Chat with Zara';
  }

  nudgeTimers.push(setTimeout(function() { if (!isOpen) bounceBubble(); }, stage1Delay));
  nudgeTimers.push(setTimeout(function() {
    if (!isOpen && nudgeDismissed === 0) {
      bubble.classList.add('bopf-proactive');
      setTimeout(function() { bubble.classList.remove('bopf-proactive'); }, 2000);
      showNudge(nudgeMsg, nudgeCTAText);
    }
  }, stage2Delay));

  var origOpen = bopfOpen;
  bopfOpen = function() { clearNudgeTimers(); hideNudge(); origOpen(); };
})();

// ── EVENT LISTENERS ───────────────────────────────────────────────────
document.getElementById('bopf-bb').addEventListener('click',function(){ if(isOpen) bopfClose(); else bopfOpen(); });
var hclose=document.getElementById('bopf-hclose'); if(hclose) hclose.addEventListener('click', bopfClose);
document.getElementById('bopf-bd').addEventListener('click',bopfClose);
document.getElementById('bopf-send').addEventListener('click',function(){ sendMessage(document.getElementById('bopf-inp').value); });
document.getElementById('bopf-inp').addEventListener('keydown',function(e){ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMessage(this.value);} });
document.getElementById('bopf-inp').addEventListener('input',function(){ this.style.height='auto'; this.style.height=Math.min(this.scrollHeight,110)+'px'; });
document.getElementById('bopf-img-btn').addEventListener('click',function(){ document.getElementById('bopf-img-input').click(); });
document.getElementById('bopf-img-input').addEventListener('change',function(){ handleImageUpload(this.files&&this.files[0]); this.value=''; });

// ── HOME STRIP (returning-visitor personalisation) ───────────────────
// A passive strip that renders into <div id="bopf-home-strip"> on the home
// page. Picks one of six states via a priority cascade. If the mount point
// isn't present or no state qualifies, renders nothing. Session-scoped
// dismissal. See bopf-home-strip.liquid for the theme section.

var HS_DISMISS_KEY = 'bopf_home_strip_dismissed';

function hsIsHomePage() {
  var p = window.location.pathname;
  return p === '/' || p === '' || p === '/index' || p === '/pages/home';
}

function hsEscape(str) {
  if (str === null || str === undefined) return '';
  return String(str).replace(/[&<>"']/g, function(c) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  });
}

function hsExtractBrand(title, fallback) {
  if (fallback) return fallback.toLowerCase();
  if (!title) return '';
  var t = title.toLowerCase();
  var brands = ['chanel','hermes','dior','gucci','louis vuitton','cartier','bottega veneta','bottega','fendi','balenciaga','prada','celine','saint laurent','burberry','valentino','bvlgari','tiffany','van cleef','loewe','miu miu','goyard','moynat','chloe','givenchy'];
  for (var i = 0; i < brands.length; i++) { if (t.indexOf(brands[i]) > -1) return brands[i]; }
  return title.split(' ')[0].toLowerCase();
}

function hsLoadViewed() {
  try {
    var raw = localStorage.getItem('bopf_viewed_v2');
    if (!raw) return [];
    var list = JSON.parse(raw);
    var cutoff = Date.now() - 7 * 24 * 60 * 60 * 1000;
    return list.filter(function(v){ return v && v.handle && v.ts > cutoff; });
  } catch(e) { return []; }
}

function hsCheckAvailability(viewed, callback) {
  if (!viewed.length) { callback([], []); return; }
  var handles = viewed.map(function(v){ return v.handle; }).filter(Boolean).slice(0, 5);
  if (!handles.length) { callback([], []); return; }
  var aliases = handles.map(function(h, i) {
    var safe = h.replace(/[^a-zA-Z0-9_-]/g, '');
    return 'p' + i + ': productByHandle(handle:"' + safe + '") { title handle availableForSale vendor images(first:1){ edges { node { url } } } priceRange { minVariantPrice { amount } } }';
  }).join(' ');
  var gql = '{ ' + aliases + ' }';
  var xhr = new _XHR();
  _xhrOpen.call(xhr, 'POST', 'https://'+DOMAIN+'/api/2026-01/graphql.json', true);
  _xhrHeader.call(xhr, 'Content-Type', 'application/json');
  _xhrHeader.call(xhr, 'X-Shopify-Storefront-Access-Token', TOKEN);
  xhr.timeout = 6000;
  xhr.onload = function() {
    try {
      var resp = JSON.parse(xhr.responseText);
      var data = (resp && resp.data) || {};
      var available = [], sold = [];
      handles.forEach(function(h, i) {
        var p = data['p' + i];
        var cached = viewed.filter(function(v){ return v.handle === h; })[0] || {};
        if (!p) return;
        var imgUrl = p.images && p.images.edges && p.images.edges[0] && p.images.edges[0].node && p.images.edges[0].node.url;
        var enriched = {
          handle: h,
          title:  p.title || cached.title,
          brand:  (p.vendor || cached.brand || '').toLowerCase(),
          image:  imgUrl || cached.image,
          priceAmt: p.priceRange && p.priceRange.minVariantPrice && parseFloat(p.priceRange.minVariantPrice.amount),
          availableForSale: p.availableForSale !== false
        };
        if (enriched.availableForSale) available.push(enriched);
        else sold.push(enriched);
      });
      callback(available, sold);
    } catch(e) { callback([], []); }
  };
  xhr.onerror = xhr.ontimeout = function() { callback([], []); };
  _xhrSend.call(xhr, JSON.stringify({ query: gql }));
}

function hsCardHTML(product, options) {
  options = options || {};
  var handle = product.handle || '';
  var title = product.title || '';
  var priceAmt = product.priceAmt
    || (product.priceRange && product.priceRange.minVariantPrice && parseFloat(product.priceRange.minVariantPrice.amount))
    || product.price || 0;
  var img = product.image
    || (product.images && product.images.edges && product.images.edges[0] && product.images.edges[0].node && product.images.edges[0].node.url);
  var brand = hsExtractBrand(title, product.brand);
  var brandDisplay = (brand || title.split(' ')[0] || '').toUpperCase();
  var rawUrl = product.url || ('https://businessofprelovedfashion.com/products/' + handle);
  var url = appendUTM(rawUrl);
  var isSold = !!options.sold;
  var isInCart = !!options.inCart;
  var imgHtml = img
    ? '<img src="' + hsEscape(img) + '" alt="' + hsEscape(title) + '" loading="lazy">'
    : '<span class="hs-mono">' + hsEscape((brand.charAt(0) || '?').toUpperCase()) + '</span>';
  var badge = '';
  if (isSold) badge = '<span class="hs-sold-badge">Sold</span>';
  else if (isInCart) badge = '<span class="hs-cart-pin">In cart</span>';
  var priceHtml = isSold
    ? '<div class="hs-price hs-sold-text">Just sold</div>'
    : '<div class="hs-price">Dhs. ' + Math.round(priceAmt).toLocaleString() + '</div>';
  if (isSold) {
    return '<div class="hs-card is-sold" data-handle="' + hsEscape(handle) + '">'
      + '<div class="hs-card-img">' + imgHtml + badge + '</div>'
      + '<div class="hs-card-body">'
      + '<div class="hs-brand">' + hsEscape(brandDisplay) + '</div>'
      + '<div class="hs-title">' + hsEscape(title) + '</div>'
      + priceHtml
      + '</div></div>';
  }
  return '<a class="hs-card" href="' + hsEscape(url) + '" data-handle="' + hsEscape(handle) + '">'
    + '<div class="hs-card-img">' + imgHtml + badge + '</div>'
    + '<div class="hs-card-body">'
    + '<div class="hs-brand">' + hsEscape(brandDisplay) + '</div>'
    + '<div class="hs-title">' + hsEscape(title) + '</div>'
    + priceHtml
    + '</div></a>';
}

function hsBuildShell(title, cardsHtml, options) {
  options = options || {};
  var metaHtml   = options.meta    ? '<span class="hs-meta">' + hsEscape(options.meta) + '</span>' : '';
  var footerHtml = options.footer  || '';
  var subnote    = options.subnote ? '<div class="hs-subnote">' + hsEscape(options.subnote) + '</div>' : '';
  var cardsCls   = options.cardsClass || '';
  return '<div class="hs-strip">'
    + '<div class="hs-hdr">'
    + '<div class="hs-av"><img src="' + LOGO + '" alt="BOPF" onerror="this.style.display=\'none\'"></div>'
    + '<div class="hs-title-main">' + hsEscape(title) + '</div>'
    + metaHtml
    + '<button class="hs-dismiss" aria-label="Dismiss">&times;</button>'
    + '</div>'
    + '<div class="hs-cards ' + cardsCls + '">' + cardsHtml + '</div>'
    + subnote
    + footerHtml
    + '</div>';
}

function hsWire(mount, stateName) {
  var dismiss = mount.querySelector('.hs-dismiss');
  if (dismiss) dismiss.addEventListener('click', function() {
    try { sessionStorage.setItem(HS_DISMISS_KEY, '1'); } catch(e) {}
    mount.style.display = 'none';
    logEvent('home_strip_dismiss', stateName);
  });
  var cards = mount.querySelectorAll('.hs-card[href]');
  cards.forEach(function(a) {
    a.addEventListener('click', function() {
      logEvent('home_strip_card_click', stateName + '|' + (a.dataset.handle || ''));
    });
  });
  logEvent('home_strip_view', stateName);
}

function hsRenderCart(mount, items, total) {
  var uae = isUAEVisitor();
  var bnplHtml = (uae && total >= 1000)
    ? '<div class="hs-bnpl">Tabby or Tamara at checkout, 0% interest</div>'
    : '';
  var cardsHtml = items.slice(0, 2).map(function(item) {
    return hsCardHTML({
      handle: item.handle,
      title:  item.title,
      priceAmt: item.priceRaw,
      image:  item.img,
      brand:  hsExtractBrand(item.title)
    }, { inCart: true });
  }).join('');
  var footer = '<div class="hs-footer">'
    + '<div class="hs-total">Cart total <strong>Dhs. ' + Math.round(total).toLocaleString() + '</strong></div>'
    + bnplHtml
    + '<a class="hs-cta" href="/cart">Complete order &rarr;</a>'
    + '</div>';
  mount.innerHTML = hsBuildShell("Your cart is still here.", cardsHtml, {
    cardsClass: 'hs-cart-2', footer: footer
  });
  hsWire(mount, 'cart');
}

// Cart has one item AND the visitor has 2+ recently-viewed items not already
// in cart. This is the "still deliberating" signal: they added something,
// kept looking, left. Frame as continuation, not pressure.
function hsRenderCartPlusViews(mount, cartItem, cartTotal, views) {
  var uae = isUAEVisitor();
  var bnplHtml = (uae && cartTotal >= 1000)
    ? '<div class="hs-bnpl">Tabby or Tamara at checkout, 0% interest</div>'
    : '';
  var cartCardHtml = hsCardHTML({
    handle: cartItem.handle,
    title:  cartItem.title,
    priceAmt: cartItem.priceRaw,
    image:  cartItem.img,
    brand:  hsExtractBrand(cartItem.title)
  }, { inCart: true });
  var viewsHtml = views.slice(0, 3).map(function(p){ return hsCardHTML(p); }).join('');
  var footer = '<div class="hs-footer">'
    + '<div class="hs-total">Cart total <strong>Dhs. ' + Math.round(cartTotal).toLocaleString() + '</strong></div>'
    + bnplHtml
    + '<a class="hs-cta" href="/cart">Complete order &rarr;</a>'
    + '</div>';
  mount.innerHTML = hsBuildShell("Pick up where you left off.", cartCardHtml + viewsHtml, {
    footer: footer
  });
  hsWire(mount, 'cart_plus_views');
}

function hsRenderViewedAvailable(mount, items) {
  var cardsHtml = items.slice(0, 4).map(function(p){ return hsCardHTML(p); }).join('');
  mount.innerHTML = hsBuildShell("Still on your mind?", cardsHtml);
  hsWire(mount, 'viewed_available');
}

function hsRenderSoldWithSimilars(mount, soldItem, similars) {
  var brandNice = (soldItem.brand || hsExtractBrand(soldItem.title) || '').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  var title = 'The ' + brandNice + ' ' + (soldItem.title || 'piece').split(brandNice).pop().trim();
  title = 'The ' + (soldItem.title || 'piece you were looking at') + ' just sold. Close matches below.';
  var soldCardHtml = hsCardHTML(soldItem, { sold: true });
  var similarsHtml = similars.slice(0, 3).map(function(p){ return hsCardHTML(p); }).join('');
  mount.innerHTML = hsBuildShell(title, soldCardHtml + similarsHtml, {
    subnote: 'Each piece is one of a kind. If it sells, it is gone, so fresh inventory is the honest answer.'
  });
  hsWire(mount, 'viewed_sold');
}

function hsRenderArchetype(mount, brandName, items) {
  var brandNice = (brandName || '').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  var cardsHtml = items.slice(0, 4).map(function(p){ return hsCardHTML(p); }).join('');
  mount.innerHTML = hsBuildShell('New ' + brandNice + ' pieces since you were last here.', cardsHtml);
  hsWire(mount, 'archetype:' + brandName);
}

function hsRenderElicitation(mount, brandName, size, items) {
  var brandNice = (brandName || '').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  var title = size
    ? 'Fresh ' + brandNice + ' pieces, including shoes in your size.'
    : 'New ' + brandNice + ' pieces for you.';
  var opts = size ? { meta: 'Size ' + size } : {};
  var cardsHtml = items.slice(0, 4).map(function(p){ return hsCardHTML(p); }).join('');
  mount.innerHTML = hsBuildShell(title, cardsHtml, opts);
  hsWire(mount, 'elicitation:' + brandName);
}

function hsRenderGeneric(mount, items) {
  var cardsHtml = items.slice(0, 4).map(function(p){ return hsCardHTML(p); }).join('');
  mount.innerHTML = hsBuildShell("Fresh in since your last visit.", cardsHtml);
  hsWire(mount, 'generic_returning');
}

function hsCascade(mount) {
  fetchCart(function(cartItems, cartTotal) {
    var viewed = hsLoadViewed();

    if (cartItems && cartItems.length) {
      // Hybrid: 1 cart item + recent browsing = "still deliberating" signal
      if (cartItems.length === 1 && viewed.length >= 2) {
        var cartHandles = cartItems
          .map(function(i){ return (i.handle || '').toLowerCase(); })
          .filter(Boolean);
        var viewedNotInCart = viewed.filter(function(v) {
          return cartHandles.indexOf((v.handle || '').toLowerCase()) === -1;
        });
        if (viewedNotInCart.length >= 2) {
          hsCheckAvailability(viewedNotInCart, function(available /*, sold */) {
            if (available.length >= 2) {
              return hsRenderCartPlusViews(mount, cartItems[0], cartTotal, available);
            }
            // Views not in stock, fall back to plain cart
            hsRenderCart(mount, cartItems, cartTotal);
          });
          return;
        }
      }
      // Standard cart state: 2+ items, or single item with no meaningful browse history
      return hsRenderCart(mount, cartItems, cartTotal);
    }

    // No cart - continue normal cascade
    if (viewed.length) {
      hsCheckAvailability(viewed, function(available, sold) {
        if (available.length >= 1) return hsRenderViewedAvailable(mount, available);
        if (sold.length >= 1) {
          var soldItem = sold[0];
          var brand = soldItem.brand || hsExtractBrand(soldItem.title);
          if (brand) {
            searchInventory(brand, function(similars) {
              similars = (similars || []).filter(function(p){ return p.handle !== soldItem.handle; });
              if (similars.length >= 2) return hsRenderSoldWithSimilars(mount, soldItem, similars);
              hsTryProfile(mount);
            });
            return;
          }
        }
        hsTryProfile(mount);
      });
      return;
    }

    hsTryProfile(mount);
  });
}

function hsTryProfile(mount) {
  // Priority 4: quiz archetype
  var archetype = getBopfArchetype();
  if (archetype && archetype.brand && archetype.brand !== 'any') {
    searchInventory(archetype.brand, function(items) {
      if (items && items.length >= 3) return hsRenderArchetype(mount, archetype.brand, items);
      hsTryElicitation(mount);
    });
    return;
  }
  hsTryElicitation(mount);
}

function hsTryElicitation(mount) {
  // Priority 5: profile elicitation
  var profile = profileLoad();
  var favs = profile.favourite_designers || [];
  if (favs.length) {
    var brand = favs[0];
    searchInventory(brand, function(items) {
      if (items && items.length >= 3) return hsRenderElicitation(mount, brand, profile.size_shoes, items);
      hsTryGeneric(mount);
    });
    return;
  }
  hsTryGeneric(mount);
}

function hsTryGeneric(mount) {
  // Priority 6: generic new arrivals
  searchInventory('__new_arrivals__', function(items) {
    if (items && items.length >= 3) return hsRenderGeneric(mount, items);
    // Nothing to show, leave mount untouched
  });
}

function renderHomeStrip() {
  if (!hsIsHomePage()) return;
  var mount = document.getElementById('bopf-home-strip');
  if (!mount) return;
  try { if (sessionStorage.getItem(HS_DISMISS_KEY) === '1') return; } catch(e) {}
  // Skip first-time visitors entirely
  var mem = memLoad();
  if (!mem.lastVisit && !(mem.sessionCount > 0) && !hsLoadViewed().length) return;
  hsCascade(mount);
}

// ── POP UP BANNER ────────────────────────────────────────────────────
// Renders an evergreen invitation to the Pop Up Series on the home page,
// below the home strip. Works alongside the home strip (different job:
// home strip = your cart/views, this banner = what's happening next).
// Hides automatically when a chapter's day passes (midnight Dubai time)
// and rolls to the next chapter. Hides entirely when all chapters have
// passed. Session-scoped dismissal. No external deps; reuses logEvent,
// appendUTM, and the page-gate helpers.
var POPUP_BANNER_DISMISS_KEY = 'bopf_popup_banner_dismissed';
var POPUP_PAGE_URL = 'https://businessofprelovedfashion.com/pages/the-bopf-popups-alquoz';

// Chapter schedule. Mirror of the EVENTS array on the Pop Up page.
// Update here and on the Pop Up page together when the schedule changes.
// chapterExpireTs anchors to midnight Dubai (UTC+4) of the day after,
// matching the Pop Up page's visibility rule exactly.
var POPUP_CHAPTERS = [
  { n: 1, date: '2026-04-25', theme: 'The Opening' },
  { n: 2, date: '2026-05-30', theme: 'Monogram Season' },
  { n: 3, date: '2026-06-27', theme: 'Silk & Smoke' },
  { n: 4, date: '2026-07-25', theme: 'Summer Archive' },
  { n: 5, date: '2026-08-29', theme: 'Endless Summer' },
  { n: 6, date: '2026-09-26', theme: 'The Return' },
  { n: 7, date: '2026-10-31', theme: 'Heritage Hermes' },
  { n: 8, date: '2026-11-28', theme: 'Winter Rarities' },
  { n: 9, date: '2026-12-26', theme: 'Year End' }
];

function popupNextChapter() {
  var now = Date.now();
  var DAY_MS = 24 * 60 * 60 * 1000;
  var DUBAI_OFFSET_MS = 4 * 60 * 60 * 1000;
  var weekdays = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  // "Today" in Dubai as YYYY-MM-DD. Shifting the epoch by the Dubai offset
  // turns the UTC components of the resulting Date into what Dubai wall
  // clocks are currently showing. This is what lets us do calendar-day
  // math anchored to Dubai regardless of where the visitor is browsing
  // from (London, New York, Karachi all land on the same answer).
  var todayIso = new Date(now + DUBAI_OFFSET_MS).toISOString().slice(0, 10);
  var todayMidnightTs = new Date(todayIso + 'T00:00:00Z').getTime();

  for (var i = 0; i < POPUP_CHAPTERS.length; i++) {
    var ch = POPUP_CHAPTERS[i];
    // Expiry: midnight Dubai of the day after the chapter. April 25's
    // entry stays current all of April 25 and rolls over at 00:01 on April 26.
    var expireTs = new Date(ch.date + 'T00:00:00+04:00').getTime() + DAY_MS;
    if (expireTs <= now) continue;

    // Calendar-day diff (Dubai). This is the fix for the off-by-one that
    // made "2 days" show up as "Tomorrow": elapsed-hours math rounds down
    // whenever you check in late in the day, because 46 hours floors to 1
    // even though the event is 2 calendar days away.
    var eventMidnightTs = new Date(ch.date + 'T00:00:00Z').getTime();
    var dayDiff = Math.round((eventMidnightTs - todayMidnightTs) / DAY_MS);

    var countdown = '';
    if (dayDiff <= 0) {
      // Same Dubai calendar day as the chapter. With 10am-7pm hours,
      // we have three sub-states. Live "In session" between open and
      // close gives a visitor refreshing the home page a "we're open
      // right now" cue that's more useful than just "Today". Outside
      // those hours but still on the chapter day (early morning or
      // post-close), "Today" stays accurate until midnight Dubai when
      // expireTs kicks in and the chapter rolls to the next one.
      var openTs  = new Date(ch.date + 'T10:00:00+04:00').getTime();
      var closeTs = new Date(ch.date + 'T19:00:00+04:00').getTime();
      if (now >= openTs && now <= closeTs) {
        countdown = 'In session';
      } else {
        countdown = 'Today';
      }
    } else if (dayDiff === 1) {
      countdown = 'Tomorrow';
    } else if (dayDiff <= 6) {
      // Within a week: weekday name is clearer than a day count and
      // matches how people naturally refer to upcoming plans.
      var wd = weekdays[new Date(ch.date + 'T12:00:00Z').getUTCDay()];
      countdown = 'This ' + wd;
    } else if (dayDiff <= 30) {
      countdown = dayDiff + ' days';
    }

    return { chapter: ch, countdown: countdown };
  }
  return null;
}

function popupFormatDate(iso) {
  // '2026-04-25' -> '25 April'. Manual to avoid Date timezone quirks.
  var parts = iso.split('-');
  var monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var day = parseInt(parts[2], 10);
  var month = monthNames[parseInt(parts[1], 10) - 1];
  return day + ' ' + month;
}

function renderPopupBanner() {
  if (!hsIsHomePage()) return;
  // Session dismissal
  try { if (sessionStorage.getItem(POPUP_BANNER_DISMISS_KEY) === '1') return; } catch(e) {}
  // Skip if no upcoming chapters
  var next = popupNextChapter();
  if (!next) return;

  // Pick a mount. Prefer sitting right after the home strip so the stack
  // reads: home strip (personalized) -> pop up banner (evergreen). If no
  // home strip on the page, create our own mount after the first main
  // content element we can find so the banner doesn't float at the top.
  var mount = document.getElementById('bopf-popup-banner');
  if (!mount) {
    mount = document.createElement('div');
    mount.id = 'bopf-popup-banner';
    mount.setAttribute('data-bopf-self', '1');
    var afterEl = document.getElementById('bopf-home-strip');
    if (afterEl && afterEl.parentNode) {
      afterEl.parentNode.insertBefore(mount, afterEl.nextSibling);
    } else {
      // Fallback: after the first <main> or after <header>. Last resort: top of body.
      var anchor = document.querySelector('main') || document.querySelector('header');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(mount, anchor.nextSibling);
      } else {
        document.body.insertBefore(mount, document.body.firstChild);
      }
    }
  }

  var ch = next.chapter;
  var dateStr = popupFormatDate(ch.date);
  var countdownHtml = next.countdown
    ? '<div class="pb-countdown">' + hsEscape(next.countdown) + '</div>'
    : '';
  var href = appendUTM(POPUP_PAGE_URL);

  mount.innerHTML =
    '<a class="pb-banner" href="' + hsEscape(href) + '" aria-label="The Pop Up Series by BOPF">'
    + '<button class="pb-dismiss" aria-label="Dismiss">&times;</button>'
    + '<svg class="pb-thread" viewBox="0 0 1200 80" preserveAspectRatio="none" aria-hidden="true">'
    +   '<path d="M 0 40 Q 150 18, 280 42 Q 410 65, 540 35 Q 680 8, 820 45 Q 960 72, 1100 38 Q 1180 22, 1200 44"/>'
    + '</svg>'
    + '<div class="pb-left">'
    +   '<span class="pb-eyebrow">The Pop Up Series</span>'
    +   '<h3 class="pb-title">'
    +     '<span>Last Saturday of every month,</span>'
    +     '<span class="pb-sig-wrap">'
    +       '<span class="pb-sig">with love from Hadiza</span>'
    +       '<svg class="pb-flourish" viewBox="0 0 72 10" aria-hidden="true">'
    +         '<path d="M 2 6 C 12 2, 26 9, 38 5 C 48 2, 60 8, 70 4"/>'
    +       '</svg>'
    +     '</span>'
    +   '</h3>'
    +   '<div class="pb-address">Find us at Goshi Warehouse City, Warehouse 29, Al Quoz</div>'
    + '</div>'
    + '<div class="pb-right">'
    +   '<div class="pb-date">'
    +     '<div class="pb-date-label">Next chapter</div>'
    +     '<div class="pb-date-main">' + hsEscape(dateStr) + '</div>'
    +     countdownHtml
    +   '</div>'
    +   '<div class="pb-arrow" aria-hidden="true">'
    +     '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
    +       '<line x1="5" y1="12" x2="19" y2="12"/>'
    +       '<polyline points="12 5 19 12 12 19"/>'
    +     '</svg>'
    +   '</div>'
    + '</div>'
    + '</a>';

  // Wire events after innerHTML
  var dismiss = mount.querySelector('.pb-dismiss');
  if (dismiss) dismiss.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    try { sessionStorage.setItem(POPUP_BANNER_DISMISS_KEY, '1'); } catch(err) {}
    mount.style.display = 'none';
    logEvent('popup_banner_dismiss', 'chapter_' + ch.n);
  });
  var banner = mount.querySelector('.pb-banner');
  if (banner) banner.addEventListener('click', function() {
    logEvent('popup_banner_click', 'chapter_' + ch.n + '|' + ch.theme);
  });
  logEvent('popup_banner_view', 'chapter_' + ch.n + '|' + (next.countdown || 'future'));
}

// ── PROMO BANNER v2 ───────────────────────────────────────────────────
// Sitewide promotion banner. Sits between the home strip and the pop-up
// banner. Config lives in a single Sheet row, served by the server with
// a 60s in-memory cache. Hidden when disabled, when fetch fails, or when
// session-dismissed.
//
// v2 changes from v1:
//   - Tall editorial layout (~80px) instead of pill strip; bigger, more
//     prominent visual weight on the home page
//   - Discount auto-extracted from subline ("40% off" pulled out and
//     rendered as a standalone 30px italic with a diagonal slash drawn
//     through it for emphasis)
//   - Multiple hand-drawn scribbles: top flourish (animated float), sub
//     underline (looping draw), diagonal slash through discount, diagonal
//     flourish under CTA - all stroke-based SVG paths
//   - Subtle shine sweep across banner (7s loop, speeds up on hover)
//   - Dismiss X (top-right) - session-only, doesn't follow banner link
//   - position:sticky + auto-collapse to thin strip when scrollY > 200,
//     so the discount + code stay visible while scrolling
//   - Mount strategy unchanged: before popup, after home strip, etc.
var PROMO_BANNER_DISMISS_KEY = 'bopf_promo_banner_dismissed';

// Pulls "X% off" or "X-Y% off" out of the subline so we can render the
// discount as a standalone visual element. Returns null if no discount
// pattern found, in which case the subline is shown as-is. The "rest" is
// what's left after we yank the discount portion AND any "enjoy / get /
// save / on / across" lead-in words.
function extractDiscount(subline) {
  if (!subline) return null;
  var m = subline.match(/(?:up to |save )?(\d+(?:[-\u2013]\d+)?\s*%\s*off)/i);
  if (!m) return null;
  var headline = m[1].replace(/\s+/g, ' ').trim();
  var rest = subline.replace(m[0], '')
    .replace(/^(enjoy|get|save)\s+/i, '')
    .replace(/^(on|across)\s+/i, '')
    .replace(/[\s,.\-:;]+$/, '')
    .replace(/^[\s,.\-:;]+/, '')
    .trim();
  // No auto-prepend - preserves original copy case. The fragment that
  // remains after stripping "Enjoy/Save/Get up to X% off" reads cleanly
  // on its own ("Bags, Shoes, Clothing..." / "everything storewide" / etc.)
  return { headline: headline, rest: rest };
}

function renderPromoBanner() {
  if (!hsIsHomePage()) { console.log('[bopf promo] skipped: not home page'); return; }
  // Session dismissal short-circuits the fetch
  try {
    if (sessionStorage.getItem(PROMO_BANNER_DISMISS_KEY) === '1') {
      console.log('[bopf promo] skipped: dismissed this session');
      return;
    }
  } catch(e) {}

  fetch('/apps/bopf/promo-banner', { credentials: 'omit' })
    .then(function(r){ return r.json(); })
    .then(function(cfg) {
      console.log('[bopf promo] config:', cfg);
      if (!cfg) { console.log('[bopf promo] skipped: empty config'); return; }
      if (!cfg.enabled) { console.log('[bopf promo] skipped: disabled in admin'); return; }
      var name = String(cfg.name || '').trim();
      var url  = String(cfg.url  || '').trim();
      if (!name) { console.log('[bopf promo] skipped: no name set'); return; }
      if (!url)  { console.log('[bopf promo] skipped: no url set');  return; }
      mountPromoBanner(
        cfg, name, url,
        String(cfg.subline || '').trim(),
        String(cfg.code || '').trim().toUpperCase()
      );
      console.log('[bopf promo] mounted (v2)');
    })
    .catch(function(err) {
      // Fail closed. Banner is decoration; home page must keep working
      // if the config endpoint is down.
      console.warn('[bopf promo] fetch failed:', err && err.message);
    });
}

function mountPromoBanner(cfg, name, url, subline, code) {
  var existing = document.getElementById('bopf-promo-banner');
  if (existing) existing.parentNode.removeChild(existing);

  var mount = document.createElement('div');
  mount.id = 'bopf-promo-banner';
  mount.setAttribute('data-bopf-self', '1');

  // Mount order preference: before popup banner -> after home strip ->
  // after main -> after header -> body top.
  var popup = document.getElementById('bopf-popup-banner');
  if (popup && popup.parentNode) {
    popup.parentNode.insertBefore(mount, popup);
  } else {
    var strip = document.getElementById('bopf-home-strip');
    if (strip && strip.parentNode) {
      strip.parentNode.insertBefore(mount, strip.nextSibling);
    } else {
      var anchor = document.querySelector('main') || document.querySelector('header');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(mount, anchor.nextSibling);
      } else {
        document.body.insertBefore(mount, document.body.firstChild);
      }
    }
  }

  var href;
  try { href = appendUTM(url); } catch(e) { href = url; }

  // Pull the "40% off" portion out of the subline if present
  var discountParts = extractDiscount(subline);
  var discountText = discountParts ? discountParts.headline : '';
  var subRest = discountParts ? discountParts.rest : subline;

  // Discount badge with diagonal slash scribble drawn through it
  var discountHtml = discountText
    ? '<div class="prm-discount-wrap">'
        + '<svg class="prm-diag-slash" viewBox="0 0 150 42" aria-hidden="true">'
          + '<path d="M 8 26 C 32 21, 60 28, 90 22 C 112 18, 132 25, 142 21"/>'
        + '</svg>'
        + '<span class="prm-discount">' + hsEscape(discountText) + '</span>'
      + '</div>'
    : '';

  // Subline with the existing looping underline preserved
  var sublineHtml = subRest
    ? '<span class="prm-sub-wrap">'
        + '<span class="prm-sub">' + hsEscape(subRest) + '</span>'
        + '<svg class="prm-sub-underline" viewBox="0 0 200 6" preserveAspectRatio="none" aria-hidden="true">'
          + '<path pathLength="100" d="M 4 3 Q 30 1 60 3 Q 100 5 140 2 Q 175 4 196 3"/>'
        + '</svg>'
      + '</span>'
    : '';

  var codeIconSvg = '<svg class="prm-code-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var codeChipHtml = code
    ? '<button type="button" class="prm-code" data-code="' + hsEscape(code) + '" aria-label="Copy code ' + hsEscape(code) + ' and shop">'
        + codeIconSvg
        + '<span class="prm-code-label">' + hsEscape(code) + '</span>'
      + '</button>'
    : '';

  var ctaArrowSvg = '<svg class="prm-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  // Three-column grid: text | discount | actions. On mobile, CSS flips
  // grid-template-columns to 1fr (single column stack). Collapsed state
  // changes the grid again to a thin single-row marquee.
  mount.innerHTML =
      '<div class="prm-wrap">'
    +   '<a class="prm" href="' + hsEscape(href) + '" aria-label="' + hsEscape(name) + '">'
    +     '<button type="button" class="prm-dismiss" aria-label="Dismiss">&times;</button>'
    +     '<div class="prm-text">'
    +       '<span class="prm-eyebrow">'
    +         '<svg class="prm-flourish-top" viewBox="0 0 30 9" aria-hidden="true"><path d="M 1 5 Q 5 1 9 5 Q 13 9 17 5 Q 21 1 25 5 Q 27 7 29 5"/></svg>'
    +         'Now on'
    +       '</span>'
    +       '<div class="prm-name">' + hsEscape(name) + '</div>'
    +       sublineHtml
    +     '</div>'
    +     discountHtml
    +     '<div class="prm-actions">'
    +       codeChipHtml
    +       '<span class="prm-cta">Shop now ' + ctaArrowSvg + '</span>'
    +       '<svg class="prm-diag-flourish" viewBox="0 0 70 14" aria-hidden="true"><path d="M 4 9 C 16 4, 30 11, 44 6 C 54 3, 62 8, 68 5"/></svg>'
    +     '</div>'
    +   '</a>'
    + '</div>';

  // ── Click-to-copy-and-navigate on the code chip ────────────────
  // Unchanged behaviour from v1: clipboard write, "Copied" label swap,
  // 320ms pause to let the pulse animation play, then navigate to href.
  var chip = mount.querySelector('.prm-code');
  if (chip) {
    chip.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var codeVal = chip.getAttribute('data-code') || '';
      var label = chip.querySelector('.prm-code-label');

      function showCopiedAndNavigate() {
        chip.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        try { logEvent('promo_banner_code_copy', name + '|' + codeVal); } catch(err) {}
        setTimeout(function() { window.location.assign(href); }, 320);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codeVal)
          .then(showCopiedAndNavigate)
          .catch(function() { legacyCopy(codeVal); showCopiedAndNavigate(); });
      } else {
        legacyCopy(codeVal); showCopiedAndNavigate();
      }

      function legacyCopy(text) {
        try {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus(); ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        } catch(err) {}
      }
    });
  }

  // ── Dismiss X ──────────────────────────────────────────────────
  // Session-scoped only. Slides up + fades, removed from DOM after the
  // CSS transition completes. preventDefault + stopPropagation prevent
  // the wrapping anchor from being followed.
  var dismissBtn = mount.querySelector('.prm-dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      try { sessionStorage.setItem(PROMO_BANNER_DISMISS_KEY, '1'); } catch(err) {}
      mount.style.transition = 'max-height .35s, opacity .25s, margin .25s, padding .25s';
      mount.style.maxHeight = mount.offsetHeight + 'px';
      // Force reflow then collapse to 0 so the transition runs
      // eslint-disable-next-line no-unused-expressions
      mount.offsetHeight;
      mount.style.maxHeight = '0';
      mount.style.opacity = '0';
      mount.style.marginTop = '0';
      mount.style.paddingTop = '0';
      mount.style.paddingBottom = '0';
      mount.style.overflow = 'hidden';
      try { logEvent('promo_banner_dismiss', name); } catch(err) {}
      setTimeout(function() { if (mount.parentNode) mount.parentNode.removeChild(mount); }, 400);
    });
  }

  // ── Scroll-aware collapse ──────────────────────────────────────
  // Collapse only when the banner has actually stuck to the top of the
  // viewport. Using getBoundingClientRect().top <= 0 means we detect the
  // exact moment position:sticky kicks in, regardless of where the banner
  // is mounted in the page flow. The previous version used a hardcoded
  // window.scrollY > 200 threshold, which collapsed too early because the
  // banner sits below the home strip and pop-up banner - users were
  // already past 200px scroll before they ever saw the banner.
  var lastCollapsed = false;
  function onScroll() {
    var rect = mount.getBoundingClientRect();
    var collapsed = rect.top <= 0;
    if (collapsed !== lastCollapsed) {
      mount.classList.toggle('is-collapsed', collapsed);
      lastCollapsed = collapsed;
    }
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // ── Click logging on the whole banner ──────────────────────────
  var anchor2 = mount.querySelector('.prm');
  if (anchor2) anchor2.addEventListener('click', function() {
    try { logEvent('promo_banner_click', name + (code ? '|' + code : '')); } catch(err) {}
  });
  try { logEvent('promo_banner_view', name + (code ? '|' + code : '')); } catch(err) {}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderHomeStrip);
  document.addEventListener('DOMContentLoaded', renderPopupBanner);
  document.addEventListener('DOMContentLoaded', renderPromoBanner);
} else {
  renderHomeStrip();
  renderPopupBanner();
  renderPromoBanner();
}

})();